import './_Dashboard.scss'
import './_CalibrationExtras.scss'
import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import {
    Box,
    Button, FormControl, FormHelperText, InputLabel, MenuItem,
    Modal, Select,
    Skeleton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Collapse,
    Typography,
    Tooltip,
    Checkbox,
    FormControlLabel
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {useEffect, useState, useRef} from "react";
import {useMutation, useQuery} from "react-query";
import {addUsers, deleteUser, editUser, editUsers, getUsers, signIn, users} from "../../../services/auth";
import {showSnackBar} from "../../Snackbar/Snackbar";
import {adDevices, deleteDevice, deleteDeviceErrors, devices, editDevices, markErrorsAsRead} from "../../../services/devices";
import {startCalibration, setCalibrationAngle} from "../../../services/calibration";
import {useNavigate} from "react-router-dom";
import {useLocalStorage} from "../../../utils/useLocalStorage";
import {
    DeviceErrorIcon,
    ExclamationTriangleIcon,
    LightningIcon, NetworkIcon, NotNetworkIcon, OverheatingIcon,
    PoorConnectionIcon,
    WrongBatteryIcon
} from "../../utils/svg-icons";
import AddDeviceWizard from './AddDeviceWizard'
import RecalibrateModal from './RecalibrateModal'
import {fontFamily, headingSx, subtextSx, btnPrimarySx, btnSecondarySx, brand} from './protoTheme'
const onIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='19' height='20' viewBox='0 0 19 20' fill='none'%3E%3Cpath fillRule='evenodd' clipRule='evenodd' d='M9.5 19.5C14.7467 19.5 19 15.2467 19 10C19 4.75329 14.7467 0.5 9.5 0.5C4.25329 0.5 0 4.75329 0 10C0 15.2467 4.25329 19.5 9.5 19.5ZM13.9085 5.77459C13.5424 5.40847 12.9488 5.40847 12.5826 5.77459C12.5738 5.78343 12.5655 5.79279 12.5578 5.80263L8.21731 11.3334L5.60041 8.71653C5.2343 8.35041 4.6407 8.35041 4.27459 8.71653C3.90847 9.08265 3.90847 9.67624 4.27459 10.0424L7.58265 13.3504C7.94876 13.7165 8.54236 13.7165 8.90847 13.3504C8.91663 13.3423 8.92432 13.3337 8.93152 13.3247L13.9218 7.08684C14.2745 6.71977 14.2701 6.13621 13.9085 5.77459Z' fill='%231E773C'/%3E%3C/svg%3E"
const offIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='19' height='20' viewBox='0 0 19 20' fill='none'%3E%3Cpath fillRule='evenodd' clipRule='evenodd' d='M9.5 19.5C14.7467 19.5 19 15.2467 19 10C19 4.75329 14.7467 0.5 9.5 0.5C4.25329 0.5 0 4.75329 0 10C0 15.2467 4.25329 19.5 9.5 19.5ZM6.09743 5.68829C5.84637 5.43724 5.43934 5.43724 5.18829 5.68829C4.93724 5.93934 4.93724 6.34637 5.18829 6.59743L8.59086 10L5.18829 13.4026C4.93724 13.6536 4.93724 14.0607 5.18829 14.3117C5.43934 14.5628 5.84637 14.5628 6.09743 14.3117L9.5 10.9091L12.9026 14.3117C13.1536 14.5628 13.5607 14.5628 13.8117 14.3117C14.0628 14.0607 14.0628 13.6536 13.8117 13.4026L10.4091 10L13.8117 6.59743C14.0628 6.34637 14.0628 5.93934 13.8117 5.68829C13.5607 5.43724 13.1536 5.43724 12.9026 5.68829L9.5 9.09086L6.09743 5.68829Z' fill='%237C7C7C'/%3E%3C/svg%3E"
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,

    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};

const modalBoxSx = {
    position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
    width: 420, maxWidth: '92vw', bgcolor: 'background.paper', boxShadow: 24, p: 4, borderRadius: 2,
    fontFamily
}

// calibState drives the calibration wizard flow layered on top of the
// existing Fleet table. 'no_link' is never stored on the device - it's
// derived from `!row.status` wherever this is used, same as everywhere
// else in this file.
const CALIB_ALERT = {
    no_link: { color: 'grey', text: 'No connection' },
    online: { color: 'grey', text: 'Configure' },
    ready: { color: 'grey', text: 'Waiting for device' },
    in_progress: { color: 'grey', text: 'Calibrating…' },
    done: null,
    interrupted: { color: 'red', text: 'Attention!' }
}

// calibStates whose alert-pill opens the description in renderPopupContent.
// 'interrupted' isn't one: its popup opens from the "Start over" button, so a
// second entry point on the pill would only duplicate it.
const CALIB_POPUP_STATES = ['in_progress']

// Tiny "where is it right now" gauge for a calibrated ('done') device -
// grey track for the full compass, navy arc for the calibrated zone
// (zoneStart -> zoneStart + sweepDegrees, always the positive/clockwise
// direction - see zoneStartAngle's comment in device_sync_api's Device
// model), gold dot for the pivot's current reported angle. Ported from the
// /calibration-prototype build (same math), just fed real field names.
const MiniDonut = ({ arcStart, arcEnd, sweepDegrees, currentAngle }) => {
    const size = 20
    const c = size / 2
    const r = c - 2
    const toXY = (deg) => {
        const rad = (deg - 90) * (Math.PI / 180)
        return [c + r * Math.cos(rad), c + r * Math.sin(rad)]
    }
    // Zone bounds are only known once calibrated ('done') - arcStart/arcEnd
    // come through undefined otherwise, and the dial then shows just the
    // plain track + current-angle dot instead of pretending to know a zone
    // that hasn't been measured yet.
    const hasZone = arcStart != null && arcEnd != null
    const fullCircle = hasZone && sweepDegrees >= 360
    const [px, py] = toXY(currentAngle)
    return (
        <svg width={size} height={size} style={{ marginRight: 6, verticalAlign: 'middle', flexShrink: 0 }}>
            <circle cx={c} cy={c} r={r} fill="none" stroke="#dedede" strokeWidth="2" />
            {hasZone && (fullCircle ? (
                <circle cx={c} cy={c} r={r} fill="none" stroke={brand.navy} strokeWidth="2" />
            ) : (
                (() => {
                    const [sx, sy] = toXY(arcStart)
                    const [ex, ey] = toXY(arcEnd)
                    const largeArc = ((arcEnd - arcStart + 360) % 360) > 180 ? 1 : 0
                    return <path d={`M ${sx} ${sy} A ${r} ${r} 0 ${largeArc} 1 ${ex} ${ey}`} fill="none" stroke={brand.navy} strokeWidth="2" />
                })()
            ))}
            {!isNaN(px) && !isNaN(py) && <circle cx={px} cy={py} r="2" fill="#e0a800" />}
        </svg>
    )
}

// Compass dial: fallback way to enter the angle when the control panel has
// no degree readout. Ported from the pre-merge wizard's "Current position"
// step (removed entirely at the time since the offset can only be set once
// a device is calibrated) - same math, now used for "set current°".
const AngleDial = ({ value, onChange }) => {
    const size = 160
    const center = size / 2
    const radius = center - 14

    const handlePick = (e) => {
        const rect = e.currentTarget.getBoundingClientRect()
        const x = e.clientX - rect.left - center
        const y = e.clientY - rect.top - center
        let deg = Math.round((Math.atan2(x, -y) * 180) / Math.PI)
        if (deg < 0) deg += 360
        onChange(deg)
    }

    const rad = (value - 90) * (Math.PI / 180)
    const needleX = center + radius * Math.cos(rad)
    const needleY = center + radius * Math.sin(rad)

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
            <svg width={size} height={size} onClick={handlePick} style={{ cursor: 'crosshair' }}>
                <circle cx={center} cy={center} r={radius} fill="#f3f2f2" stroke="#dedede" strokeWidth="1" />
                <text x={center} y={16} textAnchor="middle" fontSize="11" fill={brand.grey}>N</text>
                <text x={size - 10} y={center + 4} textAnchor="middle" fontSize="11" fill={brand.grey}>E</text>
                <text x={center} y={size - 6} textAnchor="middle" fontSize="11" fill={brand.grey}>S</text>
                <text x={10} y={center + 4} textAnchor="middle" fontSize="11" fill={brand.grey}>W</text>
                <line x1={center} y1={center} x2={needleX} y2={needleY} stroke={brand.navy} strokeWidth="3" strokeLinecap="round" />
                <circle cx={center} cy={center} r="4" fill={brand.navy} />
            </svg>
            <span style={{ ...subtextSx }}>Point the needle toward the machine: {value}°</span>
        </Box>
    )
}

const Dashboard = () => {
    const navigate = useNavigate();

    //date
    const [rows, setRows] = useState([])
    const [users, setUsers] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    //open admin tab

    //open popup add and edit
    const [open, setOpen] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [openDataAlert, setOpenDataAlert] = useState([]);
    const [removedPopup, setRemovedPopup] = useState([]);
    const [openEdit, setOpenEdit] = useState(false);
    //edit calibration popup
    const [openEditCalibration, setOpenEditCalibration] = useState(false);

    // alerts history collapse state - for each device
    const [expandedDevices, setExpandedDevices] = useState({});


    // Функція для отримання іконки за кодом помилки
    const getErrorIcon = (errorCode) => {
        switch (errorCode) {
            case 'OVERHEAT':
                return <OverheatingIcon color="#B60000" size={19} />;
            case 'BATTERY':
                return <WrongBatteryIcon color="#B60000" size={19} />;
            case 'RSSI_BAD':
                return <PoorConnectionIcon color="#B60000" size={19} />;
            case 'CALIBRATION':
                return <ExclamationTriangleIcon color="#B60000" size={19} />;
            case 'PIVOT_POWER':
                return <LightningIcon color="#B60000" size={19} />;
            case 'TS_1':
            case 'TS_2':
                return <DeviceErrorIcon color="#B60000" size={19} />;
            case 'NETWORK':
                return <NotNetworkIcon color="#B60000" size={19} />;
            default:
                return <LightningIcon color="#B60000" size={19} />;
        }
    };

    // Функція для форматування дати
    const formatAlertDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };

    // Коротка версія дати для попапу
    const formatAlertDateShort = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };

    const toggleDeviceExpand = (deviceId) => {
        setExpandedDevices(prev => ({
            ...prev,
            [deviceId]: !prev[deviceId]
        }));
    };

    const [userRole, setRole] = useLocalStorage("role", "");

    // Despite the name this is "show the device Fleet table" (false = the Users
    // admin panel). Everyone starts on the Fleet - non-admin roles see their own
    // devices (the backend scopes GET /devices by owner); only an admin gets
    // the toggle to the Users panel and the /users request behind it.
    const [openAdminUi, setOpenAdminUi] = useState(true);

    // Auto-syncer state - saved to localStorage, enabled by default
    const [autoSync, setAutoSync] = useLocalStorage("autoSync", true);
    const autoSyncIntervalRef = useRef(null);
    const isAutoSyncRef = useRef(false); // Flag to track if update is from auto-sync

    const handleOpen = () => setOpen(true);

    const handleClose = () => setOpen(false);

    const handleOpenAlert = (deviceData) => {
        setOpenDataAlert(deviceData);
        setOpenAlert(true);
    };

    // Закриття хрестиком - відправляємо запит що прочитано для кожної помилки
    const handleRemovedPopup = async (deviceId) => {
        try {
            // Знаходимо девайс
            const device = rows.find(row => row._id === deviceId);
            if (!device) return;

            const recentErrors = device.recentErrors || [];

            // Позначаємо кожну помилку як прочитану по одній
            for (const error of recentErrors) {
                try {
                    await markErrorsAsRead(deviceId, error._id);
                } catch (err) {
                    console.error(`Failed to mark error ${error._id} as read:`, err);
                }
            }

            // Оновлюємо дані девайса - переміщуємо помилки з recentErrors в errorHistory
            setRows(prevRows => prevRows.map(row => {
                if (row._id === deviceId) {
                    const now = new Date().toISOString();
                    const currentRecentErrors = row.recentErrors || [];
                    const currentErrorHistory = row.errorHistory || [];

                    // Додаємо readAt до непрочитаних і переміщуємо в історію
                    const newReadErrors = currentRecentErrors.map(error => ({
                        ...error,
                        readAt: now
                    }));

                    // Об'єднуємо: нові спочатку, потім старі, обмежуємо до 5 елементів
                    const combinedHistory = [...newReadErrors, ...currentErrorHistory].slice(0, 5);

                    return {
                        ...row,
                        recentErrors: [], // Очищуємо непрочитані
                        errorHistory: combinedHistory, // Додаємо в історію (максимум 5, найновіші спочатку)
                        unreadErrorsCount: 0
                    };
                }
                return row;
            }));
            showSnackBar("success", "Alerts marked as read");
        } catch (error) {
            showSnackBar("error", "Failed to mark alerts as read");
        }
        setOpenAlert(false);
    };

    // Стрілочка вниз - просто скриваємо попап без відправки запиту
    const handleCloseAlert = () => setOpenAlert(false);

    const handleEditOpen = () => setOpenEdit(true);
    const handleCloseEdit = () => setOpenEdit(false);

    const handleEditCalibration = () => setOpenEditCalibration(true);
    const handleCloseCalibrationEdit = () => setOpenEditCalibration(false);

    const [newDevice, setNewDevice] = useState({deviceName: '', deviceId: '', currentLocation: 'N/A', sweepDegrees: ''});
    const [editDevice, setEditDevice] = useState({deviceName: '', deviceId: '', currentLocation: 'N/A', recalibrate:false, sweepDegrees: ''});
    const clearUserModel = {firstName: '', lastName: '', email: '', password: '', status: 'pending'}
    const [newUser, setNewUser] = useState(clearUserModel);

    const [editUser, setEditUser] = useState({});

    // Calibration wizard state - layered on top of the existing Fleet table,
    // none of it touches newDevice/editDevice/the mutations above.
    const [wizard, setWizard] = useState({ open: false, startStep: 1, initialData: {}, targetRowId: null })
    const [recalRowId, setRecalRowId] = useState(null)
    const [quickAngleRowId, setQuickAngleRowId] = useState(null)
    const [quickAngleValue, setQuickAngleValue] = useState('')
    const [quickAngleNoPanel, setQuickAngleNoPanel] = useState(false)
    const [popupRowId, setPopupRowId] = useState(null)

    const {refetch: fetchDevices} = useQuery(['devices'], () => devices(), {
        enabled: false,
        retry: false,
        onSuccess: (data) => {
            setIsLoading(false)
            // Обробляємо дані щоб гарантувати правильну структуру
            const processedData = data.map(device => ({
                ...device,
                recentErrors: device.recentErrors || [], // Непрочитані помилки
                errorHistory: (device.errorHistory || []).slice(0, 5) // Тільки останні 5 прочитаних
            }));

            // Сортуємо: активні девайси (status=true) вгорі
            const sortedData = processedData.sort((a, b) => {
                // Якщо обидва активні або обидва неактивні - залишаємо порядок
                if (a.status === b.status) return 0;
                // Активні (true) йдуть вгору, тому повертаємо -1 для a.status=true
                return a.status ? -1 : 1;
            });

            // Calibration just finished (the device started reporting its
            // angle) - the row updates silently otherwise, so let the user know. Skipped on the very
            // first load (rows is still empty then - nothing to compare against).
            if (rows.length > 0) {
                sortedData.forEach((newRow) => {
                    const oldRow = rows.find((r) => r._id === newRow._id)
                    if (oldRow && oldRow.calibState !== 'done' && newRow.calibState === 'done') {
                        showSnackBar('success', `${newRow.deviceName}: Calibration completed`)
                    }
                })
            }

            setRows(sortedData)
            isAutoSyncRef.current = false; // Reset flag after processing
        },
        onError: (error) => {
            setIsLoading(false)
            if (!isAutoSyncRef.current) {
                navigate('/login');
                showSnackBar("error", `${error.message?.status === 401 ? 'The session is not active!' : error?.error?.message}`)
            }
            isAutoSyncRef.current = false; // Reset flag after processing
        }
    })

    // Manual refresh icon in the status column - same fetchDevices() the 5s
    // autoSync loop already uses, but this one is a deliberate click so it
    // gets its own spin animation + confirmation toast (autoSync stays silent
    // to avoid toasting every 5 seconds).
    const [manualRefreshingId, setManualRefreshingId] = useState(null)
    const handleManualRefresh = async (rowId) => {
        setManualRefreshingId(rowId)
        const result = await fetchDevices()
        setManualRefreshingId(null)
        if (!result?.isError) showSnackBar('success', 'Device updated')
    }

    // Toolbar refresh button: reloads the whole table (Fleet, or Users for an
    // admin who switched to it) and confirms with a toast - the failure case
    // is already reported by the query's own onError.
    const handleToolbarRefresh = async () => {
        setIsLoading(true)
        const result = await (openAdminUi ? fetchDevices() : fetchAllUsers())
        if (!result?.isError) showSnackBar('success', openAdminUi ? 'Devices updated' : 'Users updated')
    }

    const {refetch: fetchAllUsers} = useQuery(['users'], () => getUsers(), {
        enabled: false,
        retry: false,
        onSuccess: (data) => {
            setIsLoading(false)
            setUsers(data)
        },
        onError: (error) => {
            setIsLoading(false)
            navigate('/login');
            showSnackBar("error", `${error.message?.status === 401 ? 'The session is not active!' : error?.error?.message}`)
        }
    })

    const addDevice = useMutation({
        mutationFn: () => {
            return adDevices({newDevice})
        },
        onError: (error, variables, context) => {
            showSnackBar("error", `${error.response?.status === 401 ? 'The session is not active!' : error?.message}`)
        },
        onSuccess: (data, variables, context) => {
            if (data?.error?.message?.length > 0) {
                showSnackBar("error", data?.error?.message)
            } else {
                showSnackBar("success", 'Device added!')
                handleClose()
                setIsLoading(true)
                fetchDevices()
            }
        },
    })
    const addUser = useMutation({
        mutationFn: () => {
            return addUsers({newUser})
        },
        onError: (error, variables, context) => {
            showSnackBar("error", `${error.message?.status === 401 ? 'The session is not active!' : error?.error?.message}`)
        },
        onSuccess: (data, variables, context) => {
            if (data?.error?.message?.length > 0) {
                showSnackBar("error", data?.error?.message)
            } else {
                showSnackBar("success", 'User added!')
                handleClose()
                setNewUser(clearUserModel)
                setIsLoading(true)
                fetchAllUsers()
            }
        },
    })

    const updateDevice = useMutation({
        mutationFn: () => {
            // The sweep isn't editable here (it's set in the calibration
            // wizard) - don't send the row's copy back and risk overwriting a
            // newer value with a stale one.
            // eslint-disable-next-line no-unused-vars
            const {sweepDegrees, ...rest} = editDevice
            return editDevices({editDevice: rest})
        },
        onError: (error, variables, context) => {
            showSnackBar("error", `${error.message?.status === 401 ? 'The session is not active!' : error?.error?.message}`)
        },
        onSuccess: (data, variables, context) => {
            if (data?.error?.message?.length > 0) {
                showSnackBar("error", data?.error?.message)
            } else {
                handleCloseEdit()
                handleCloseCalibrationEdit()
                // setRows([...rows, data])
                if(data.message==='Recalibration command sent'){
                    showSnackBar("success", 'Recalibration command sent');
                }else {
                    setIsLoading(true)
                    fetchDevices()
                }

            }
        },
    })

    const updateUser = useMutation({
        mutationFn: () => {
            return editUsers({editUser})
        },
        onError: (error, variables, context) => {
            showSnackBar("error", `${error.message?.status === 401 ? 'The session is not active!' : error?.error?.message}`)
        },
        onSuccess: (data, variables, context) => {
            if (data?.error?.message?.length > 0) {
                showSnackBar("error", data?.error?.message)
            } else {
                handleCloseEdit()
                setIsLoading(true)
                fetchAllUsers()
            }
        },
    })

    const removeDevice = useMutation({
        mutationFn: (id) => {
            return deleteDevice({id})
        },
        onError: (error, variables, context) => {
            showSnackBar("error", `${error.message?.status === 401 ? 'The session is not active!' : error?.error?.message}`)
        },
        onSuccess: (data, variables, context) => {
            if (data?.error?.message?.length > 0) {
                showSnackBar("error", data?.error?.message)
            } else {
                showSnackBar("success", 'Device deleted!')
                setIsLoading(true)
                fetchDevices()
            }
        },
    })

    const removeUser = useMutation({
        mutationFn: (id) => {
            return deleteUser({id})
        },
        onError: (error, variables, context) => {
            showSnackBar("error", `${error.message?.status === 401 ? 'The session is not active!' : error?.error?.message}`)
        },
        onSuccess: (data, variables, context) => {
            if (data?.error?.message?.length > 0) {
                showSnackBar("error", data?.error?.message)
            } else {
                showSnackBar("success", 'User deleted!')
                setIsLoading(true)
                fetchAllUsers()
            }
        },
    })
    const removeAlerts = useMutation({
        mutationFn: (deviceId) => {
            return deleteDeviceErrors(deviceId)
        },
        onError: (error) => {
            showSnackBar("error", `${error.message?.status === 401 ? 'The session is not active!' : error?.error?.message}`)
        },
        onSuccess: () => {
            showSnackBar("success", 'Alerts removed!')
            setIsLoading(true)
            fetchDevices()
        },
    })

    const addNewDevice = () => {
        const hasEmptyFields = Object.values(newDevice).some(value => value === '');

        if (hasEmptyFields) {
            showSnackBar('error', 'Oops... something\'s wrong, please check all fields!')
        } else {
            addDevice.mutate()
        }
    }
    const addNewUser = () => {
        const hasEmptyFields = Object.values(newUser).some(value => value === '');
        const isPasswordLongEnough = newUser.password.length > 6;

        if (hasEmptyFields) {
            return showSnackBar('error', 'Some fields are empty.');
        }

        if (!isPasswordLongEnough) {
            return showSnackBar('error', 'Password must be longer than 7 characters.');
        }

        addUser.mutate()

    }
    const editDeviceChecker = () => {
        const hasEmptyFields = Object.values(editDevice).some(value => value === '');

        if (hasEmptyFields) {
            showSnackBar('error', 'Oops... something\'s wrong, please check all fields!')
        } else {
            updateDevice.mutate()
        }
    }
    const editUserChecker = () => {

        if(editUser?.password?.length > 6 && editUser?.password !== undefined){
            updateUser.mutate()
        }else if(editUser?.password === undefined ){
            updateUser.mutate()
        }else {
            showSnackBar('error', 'Oops... something\'s wrong, please check all fields!')
        }

    }

    useEffect(() => {
        setIsLoading(true)
        fetchDevices()
    }, []);

    // Auto-syncer effect - refreshes device data every 5 seconds when enabled
    useEffect(() => {
        if (autoSync && openAdminUi) {
            // Set initial interval
            autoSyncIntervalRef.current = setInterval(() => {
                isAutoSyncRef.current = true; // Mark as auto-sync update
                fetchDevices(); // The flag will be reset in onSuccess/onError callbacks
            }, 5000); // 5 seconds

            // Cleanup on unmount or when autoSync changes
            return () => {
                if (autoSyncIntervalRef.current) {
                    clearInterval(autoSyncIntervalRef.current);
                }
            };
        }
    }, [autoSync, openAdminUi]);

    useEffect(() => {
        if (openAdminUi && userRole === 'admin') {
            setIsLoading(true)
            fetchAllUsers()
        }
    }, [openAdminUi]);

    const editDeviceFn = (id) => {
        handleEditOpen();
        setEditDevice(rows.find((item) => item._id === id));
    }

    const editUserFn = (id) => {
        handleEditOpen();
        setEditUser(users.find((item) => item._id === id));
    }
    const editDeviceCalibrationFn = (id) => {
        handleEditCalibration();
        setEditDevice(rows.find((item) => item._id === id));
    }

    const deviceCalibrationFn = (id) => {
        if (window.confirm("Are you sure you want to recalibrate this device?")) {
            setEditDevice({ ...rows.find((item) => item._id === id),  recalibrate: true });
        }
    }
    useEffect(() => {
        if(editDevice.recalibrate){
            updateDevice.mutate();
        }
    },[editDevice])

    const handleInputChange = (e) => {
        const { value } = e.target;
        console.log(value);


        if (/^\d*$/.test(value)) {

            const numericValue = Number(value);
            if (numericValue >= 0 && numericValue <= 360) {
                setEditDevice({ ...editDevice, currentLocation: value });
            }
        }
    };

    const patchRow = (id, patch) => setRows((rs) => rs.map((r) => (r._id === id ? { ...r, ...patch } : r)))

    const popupRow = rows.find((r) => r._id === popupRowId)
    const recalRow = rows.find((r) => r._id === recalRowId)
    const quickAngleRow = rows.find((r) => r._id === quickAngleRowId)

    const openWizardResume = (row, startStep) => setWizard({
        open: true, startStep, targetRowId: row._id, deviceOnline: !!row.status,
        initialData: { deviceId: row.deviceId, deviceName: row.deviceName, zoneWidth: row.sweepDegrees ?? null }
    })

    // A never-before-seen device can't be checked for online status until
    // it's created - optimistic here, the backend still rejects startNow
    // if it turns out to be offline and the wizard surfaces that error.
    const openWizardForNew = () => setWizard({ open: true, startStep: 1, initialData: {}, targetRowId: null, deviceOnline: true })

    const closeWizard = () => setWizard((w) => ({ ...w, open: false }))

    // A second click landing before the first request returns (~450ms) used
    // to fire /calibration/start twice and publish the calibrate command to
    // the device twice. The ref blocks it synchronously (state alone wouldn't
    // until the next render); the state just disables the buttons visibly.
    const [wizardSubmitting, setWizardSubmitting] = useState(false)
    const wizardSubmittingRef = useRef(false)
    const handleWizardFinish = async (payload) => {
        if (wizardSubmittingRef.current) return
        wizardSubmittingRef.current = true
        setWizardSubmitting(true)
        try {
            await runWizardFinish(payload)
        } finally {
            wizardSubmittingRef.current = false
            setWizardSubmitting(false)
        }
    }

    const runWizardFinish = async ({ deviceId, deviceName, zoneWidth, startNow }) => {
        if (!wizard.targetRowId) {
            // New device - same real POST /device the old Add Device modal
            // used, then immediately configure/start calibration with what
            // the wizard just collected.
            let created
            try {
                created = await adDevices({ newDevice: { deviceId, deviceName, sweepDegrees: zoneWidth } })
                if (created?.error) {
                    showSnackBar('error', created.error.message)
                    return
                }
            } catch (e) {
                showSnackBar('error', e?.error?.message || 'Could not add device')
                return
            }
            // Device now exists - switch the wizard into "existing device"
            // mode right away, before attempting to start calibration. If
            // that next call fails (e.g. device offline), retrying "Start
            // calibration" must resume this device, not try to re-create
            // the same device id and fail with "used!".
            setWizard((w) => ({ ...w, targetRowId: created._id }))
            setIsLoading(true)
            fetchDevices()
            try {
                await startCalibration(created._id, { sweepDegrees: zoneWidth, startNow })
            } catch (e) {
                const message = e?.error?.message || 'Could not start calibration'
                showSnackBar('error', message)
                if (message.toLowerCase().includes('offline')) {
                    setWizard((w) => ({ ...w, deviceOnline: false }))
                }
                return
            }
            showSnackBar('success', 'Device added!')
            closeWizard()
            return
        }
        try {
            const { device } = await startCalibration(wizard.targetRowId, { sweepDegrees: zoneWidth, startNow })
            patchRow(wizard.targetRowId, { sweepDegrees: device.sweepDegrees, calibState: device.calibState })
        } catch (e) {
            showSnackBar('error', e?.error?.message || 'Could not start calibration')
            return
        }
        closeWizard()
    }

    const handleRecalPick = async (reason, quickAngle) => {
        const row = recalRow
        setRecalRowId(null)
        if (!row) return
        if (reason === 'offset') {
            try {
                await setCalibrationAngle(row._id, quickAngle)
                showSnackBar('success', 'Angle offset command sent')
            } catch (e) {
                showSnackBar('error', e?.error?.message || 'Could not send angle offset')
            }
            return
        }
        if (reason === 'zone') {
            openWizardResume(row, 2)
            return
        }
        openWizardResume({ ...row, deviceId: '', zoneWidth: null, currentAngle: '' }, 1)
    }

    const openQuickAngle = (row) => {
        setQuickAngleRowId(row._id)
        setQuickAngleValue(String(row.az ?? ''))
        setQuickAngleNoPanel(false)
    }
    const saveQuickAngle = async () => {
        const rowId = quickAngleRowId
        setQuickAngleRowId(null)
        try {
            await setCalibrationAngle(rowId, quickAngleValue)
            showSnackBar('success', 'Angle offset command sent')
        } catch (e) {
            showSnackBar('error', e?.error?.message || 'Could not send angle offset')
        }
    }

    const renderCalibAction = (row) => {
        switch (row.calibState) {
            case 'online': return <div className="calibration-btn" onClick={() => openWizardResume(row, 2)}>Configure</div>
            case 'ready': return <div className="calibration-btn" onClick={() => openWizardResume(row, 3)}>Start calibration</div>
            // Explain what happened first; the popup's own button starts the wizard.
            case 'interrupted': return <div className="calibration-btn calibration-btn-danger" onClick={() => setPopupRowId(row._id)}>Start over</div>
            default: return null
        }
    }

    const renderPopupContent = (row) => {
        if (!row) return null
        if (row.calibState === 'in_progress') {
            return (
                <Box>
                    <h3 style={headingSx}>Calibration in progress</h3>
                    <div style={{ fontFamily, fontSize: 14, lineHeight: 2 }}>
                        The device is calibrating. Its angle will appear here as soon as the calibration is finished.
                    </div>
                </Box>
            )
        }
        if (row.calibState === 'interrupted') {
            return (
                <Box>
                    <h3 style={headingSx}>Calibration interrupted</h3>
                    <div style={{ fontFamily, fontSize: 14, margin: '16px 0 20px' }}>
                        The device was offline for more than 20 minutes during calibration. Progress isn't saved, a new pass is needed.
                    </div>
                    <Button variant="contained" sx={btnPrimarySx} onClick={() => { setPopupRowId(null); openWizardResume(row, 2) }}>Start over</Button>
                </Box>
            )
        }
        return null
    }
    return (<>
            <Header/>
            <div className='dashboard-wrapper'>
                <Modal open={openAlert} onClose={handleCloseAlert} aria-labelledby="modal-modal-title"
                       aria-describedby="modal-modal-description">
                    <Box sx={{ ...style, width: '252px',padding:0 ,border: '1px solid rgba(0, 0, 0, 0.2)', borderRadius: '7px'}}>
                        <div className='headerBoxPopup' style={{position:"relative", padding: '16px', background:'#fff',borderTopLeftRadius: '7px',borderTopRightRadius: '7px' }}>
                            <p style={{color: '#4a4a4abd', fontSize:'12px'}}>Device Name: <span>{openDataAlert?.deviceName}</span></p>
                            <span>Attention! {openDataAlert?.recentErrors?.[0] ? formatAlertDateShort(openDataAlert.recentErrors[0].eventAt) : ''}</span>
                            <div className='setPopup' >
                                <svg onClick={()=>handleCloseAlert()} xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
                                    <g clipPath="url(#clip0_2261_951)">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M0.396447 0.396447C0.591709 0.201184 0.908291 0.201184 1.10355 0.396447L6.75 6.04289L12.3964 0.396447C12.5917 0.201184 12.9083 0.201184 13.1036 0.396447C13.2988 0.591709 13.2988 0.908291 13.1036 1.10355L7.10355 7.10355C6.90829 7.29882 6.59171 7.29882 6.39645 7.10355L0.396447 1.10355C0.201184 0.908291 0.201184 0.591709 0.396447 0.396447Z" fill="#7C7C7C" stroke="#7C7C7C" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_2261_951">
                                            <rect width="14" height="8" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <svg onClick={()=>handleRemovedPopup(openDataAlert?._id)} xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                    <path d="M0.209209 0.209209C0.488155 -0.0697365 0.940416 -0.0697365 1.21936 0.209209L5 3.98985L8.78064 0.209209C9.05958 -0.0697365 9.51184 -0.0697365 9.79079 0.209209C10.0697 0.488155 10.0697 0.940416 9.79079 1.21936L6.01015 5L9.79079 8.78064C10.0697 9.05958 10.0697 9.51184 9.79079 9.79079C9.51184 10.0697 9.05958 10.0697 8.78064 9.79079L5 6.01015L1.21936 9.79079C0.940416 10.0697 0.488155 10.0697 0.209209 9.79079C-0.0697365 9.51184 -0.0697365 9.05958 0.209209 8.78064L3.98985 5L0.209209 1.21936C-0.0697365 0.940416 -0.0697365 0.488155 0.209209 0.209209Z" fill="#7C7C7C"/>
                                </svg>
                            </div>
                        </div>
                        <div className='contentBoxPopup'  style={{ padding: '15px 26px', background:'rgba(124,124,124,0.05)'}}>
                            {openDataAlert?.recentErrors?.map((error, idx) => (
                                error.errors?.map((err, errIdx) => (
                                    <div className='item' key={`${idx}-${errIdx}`}>
                                        {getErrorIcon(err.code)}
                                        <p>{err.message}</p>
                                    </div>
                                ))
                            ))}
                        </div>
                    <div>

                    </div>
                    </Box>
                </Modal>
                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title"
                       aria-describedby="modal-modal-description">
                    <Box sx={style}>
                        <div
                            component="form"
                            sx={
                                {
                                    '& .MuiTextField-root': {m: 1, width: '100px'},
                                }
                            }
                            noValidate
                            autoComplete="off"
                        >
                            <div >
                                {openAdminUi ? <div className='flex form-box'>
                                    <TextField
                                        id="standard-helperText"
                                        label="Device ID"
                                        required
                                        helperText="Enter your device ID"
                                        variant="standard"
                                        onChange={(e) => setNewDevice({...newDevice, deviceId: e.target.value})}
                                        value={newDevice.id}
                                    />
                                    <TextField
                                        id="standard-helperText"
                                        label="Device name"
                                        required
                                        helperText="Name the device."
                                        variant="standard"
                                        onChange={(e) => setNewDevice({...newDevice, deviceName: e.target.value})}
                                        value={newDevice.name}
                                    />
                                    <TextField
                                        id="standard-helperText"
                                        label="Sweep angle (0-360°)"
                                        required
                                        type="number"
                                        helperText="Degrees of the circle this pivot covers at this field"
                                        variant="standard"
                                        onChange={(e) => setNewDevice({...newDevice, sweepDegrees: e.target.value})}
                                        value={newDevice.sweepDegrees}
                                    />
                                </div> : <div className='flex form-box'>
                                    <TextField
                                        id="standard-helperText"
                                        label="First Name"
                                        helperText="Enter your First Name"
                                        required
                                        variant="standard"

                                        onChange={(e) => setNewUser({...newUser, firstName: e.target.value})}
                                        value={newUser.firstName}
                                    />
                                    <TextField
                                        id="standard-helperText"
                                        label="Last Name"
                                        helperText="Enter your Last Name"
                                        required
                                        variant="standard"
                                        onChange={(e) => setNewUser({...newUser, lastName: e.target.value})}
                                        value={newUser.lastName}
                                    />
                                    <TextField
                                        id="standard-helperText"
                                        label="Email"
                                        required
                                        variant="standard"
                                        helperText="Enter your Email"

                                        onChange={(e) => setNewUser({...newUser, email: e.target.value})}
                                        value={newUser.email}
                                    />
                                    <TextField
                                        id="standard-helperText"
                                        label="Password"
                                        required
                                        variant="standard"
                                        helperText="Enter password(min 7 characters)"

                                        onChange={(e) => setNewUser({...newUser, password: e.target.value})}
                                        value={newUser.password}
                                    />
                                    <FormControl variant="standard">
                                        <InputLabel id="demo-simple-select-standard-label">Status</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-standard-label"
                                            id="demo-simple-select-helper"
                                            onChange={(e) => setNewUser({...newUser, status: e.target.value})}
                                            value={newUser.status}
                                            defaultValue={newUser.status}
                                            label="Status"

                                        >

                                            <MenuItem value={'pending'}>Pending</MenuItem>
                                            <MenuItem value={'approved'}>Approved</MenuItem>
                                        </Select>
                                        <FormHelperText>Change status user</FormHelperText>
                                    </FormControl>

                                </div>}

                            </div>
                            <div style={{marginTop: '10px'}} className="btn-add-device">
                                <Button onClick={()=> !openAdminUi ? addNewUser() : addNewDevice()} variant="outlined" startIcon={<AddIcon/>}> ADD</Button>
                            </div>
                        </div>
                    </Box>
                </Modal>
                <Modal open={openEdit} onClose={handleCloseEdit} aria-labelledby="modal-modal-title"
                       aria-describedby="modal-modal-description">
                    <Box sx={style}>
                        <div
                            component="form"
                            sx={
                                {
                                    '& .MuiTextField-root': {m: 1, width: '100px'},
                                }
                            }
                            noValidate
                            autoComplete="off"
                        >
                            <div>
                                {openAdminUi ?
                                    <div className='flex form-box'>
                                        <TextField
                                            id="standard-helperText"
                                            label="Device name"
                                            required
                                            helperText="Name the device."
                                            variant="standard"
                                            defaultValue={editDevice.deviceName}
                                            onChange={(e) => setEditDevice({...editDevice, deviceName: e.target.value})}
                                            value={newDevice.name}
                                        />


                                        <TextField
                                            id="standard-helperText"
                                            label="Device ID"
                                            required
                                            helperText="Enter your device ID"
                                            variant="standard"
                                            defaultValue={editDevice.deviceId}
                                            onChange={(e) => setEditDevice({...editDevice, deviceId: e.target.value})}
                                            value={newDevice.id}
                                            disabled
                                        />
                                    </div> :
                                    <div className='flex form-box'>
                                        <TextField
                                            id="standard-helperText"
                                            label="First Name"
                                            helperText="Enter your First Name"
                                            required
                                            variant="standard"
                                            defaultValue={editUser?.firstName}
                                            onChange={(e) => setEditUser({...editUser, firstName: e.target.value})}
                                            // value={newUser.firstName}
                                        />
                                        <TextField
                                            id="standard-helperText"
                                            label="Last Name"
                                            helperText="Enter your Last Name"
                                            required
                                            variant="standard"
                                            defaultValue={editUser?.lastName}
                                            onChange={(e) => setEditUser({...editUser, lastName: e.target.value})}
                                            // value={newUser.lastName}
                                        />
                                        <TextField
                                            id="standard-helperText"
                                            label="Email"
                                            required
                                            variant="standard"
                                            helperText="Enter your Email"
                                            defaultValue={editUser?.email}
                                            onChange={(e) => setEditUser({...editUser, email: e.target.value})}
                                            // value={newUser.email}
                                        />
                                        <TextField
                                            id="standard-helperText"
                                            label="Password"
                                            // required
                                            variant="standard"
                                            helperText="Enter new password(optional) min 7 characters."
                                            defaultValue={editUser?.password}
                                            onChange={(e) => setEditUser({...editUser, password: e.target.value})}
                                            // value={newUser.password}
                                        />
                                        <FormControl variant="standard">
                                            <InputLabel id="demo-simple-select-standard-label">Status</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-standard-label"
                                                id="demo-simple-select-helper"
                                                onChange={(e) => setEditUser({...editUser, status: e.target.value})}

                                                label="Status"
                                                defaultValue={editUser?.status}
                                            >

                                                <MenuItem value={'pending'}>Pending</MenuItem>
                                                <MenuItem value={'approved'}>Approved</MenuItem>
                                            </Select>
                                            <FormHelperText>Change status user</FormHelperText>
                                        </FormControl>

                                    </div>
                                }
                            </div>
                            <div style={{marginTop: '10px'}} className="btn-add-device">
                                <Button onClick={()=> !openAdminUi ? editUserChecker() : editDeviceChecker()} variant="outlined"> Update</Button>
                            </div>
                        </div>
                    </Box>
                </Modal>
                <Modal open={openEditCalibration} onClose={handleCloseCalibrationEdit}
                       aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    <Box sx={style}>
                        <div
                            component="form"
                            sx={
                                {
                                    '& .MuiTextField-root': {m: 1, width: '100px'},
                                }
                            }
                            noValidate
                            autoComplete="off"
                        >
                            <div className='flex form-box'>
                                <TextField
                                    id="standard-helperText"
                                    label="E.g. 90°"
                                    required
                                    helperText="Enter your current pivot location(0-360°)"
                                    variant="standard"
                                    type="number"
                                    defaultValue={editDevice.currentLocation}
                                    onChange={handleInputChange}
                                    value={editDevice.currentLocation}
                                />

                            </div>
                            <div style={{marginTop: '10px'}} className="btn-add-device">
                                <Button onClick={editDeviceChecker} variant="outlined"> Calibrate</Button>
                            </div>
                        </div>
                    </Box>
                </Modal>

                <AddDeviceWizard
                    open={wizard.open}
                    onClose={closeWizard}
                    onFinish={handleWizardFinish}
                    startStep={wizard.startStep}
                    initialData={wizard.initialData}
                    existingDevice={!!wizard.targetRowId}
                    deviceOnline={wizard.deviceOnline}
                    submitting={wizardSubmitting}
                />

                <RecalibrateModal
                    open={!!recalRow}
                    onClose={() => setRecalRowId(null)}
                    onPickReason={handleRecalPick}
                />

                <Modal open={!!quickAngleRow} onClose={() => setQuickAngleRowId(null)}>
                    <Box sx={modalBoxSx}>
                        <h3 style={headingSx}>Current angle</h3>
                        {!quickAngleNoPanel && (
                            <TextField
                                label="Angle from panel" type="number" variant="standard" fullWidth sx={{ mt: 2 }}
                                value={quickAngleValue} onChange={(e) => setQuickAngleValue(e.target.value)}
                            />
                        )}
                        <FormControlLabel
                            sx={{ mt: 1, '& .MuiFormControlLabel-label': { fontFamily, fontSize: 14 } }}
                            control={<Checkbox checked={quickAngleNoPanel} onChange={(e) => setQuickAngleNoPanel(e.target.checked)} sx={{ color: brand.navy, '&.Mui-checked': { color: brand.navy } }} />}
                            label="The panel doesn't show degrees"
                        />
                        {quickAngleNoPanel && (
                            <Box sx={{ display: 'flex', justifyContent: 'center', my: 1 }}>
                                <AngleDial value={Number(quickAngleValue) || 0} onChange={(deg) => setQuickAngleValue(String(deg))} />
                            </Box>
                        )}
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 3 }}>
                            <Button sx={{ ...btnSecondarySx, border: 'none' }} onClick={() => setQuickAngleRowId(null)}>Cancel</Button>
                            <Button variant="contained" sx={btnPrimarySx} onClick={saveQuickAngle}>Save</Button>
                        </Box>
                    </Box>
                </Modal>

                <Modal open={!!popupRow} onClose={() => setPopupRowId(null)}>
                    <Box sx={modalBoxSx}>{renderPopupContent(popupRow)}</Box>
                </Modal>

                <div className='container' style={{width: '100%'}}>
                    <div className='top-button'>
                        <Stack direction="row" spacing={2}>

                            {(userRole === 'admin') &&
                                <Button className='add-custom-btn' onClick={() => setOpenAdminUi(!openAdminUi)}
                                        variant="outlined">
                                    {!openAdminUi ?
                                        <img className='super-admin-btn'
                                             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAvAAAALwCAYAAADxpkF6AAAABmJLR0QA/wD/AP+gvaeTAAAgAElEQVR4nOzdd7hlVX3/8fedYQq9D0hnqEpTiogIKvYoKkaNDUw0NoxgiWLiL0piCtEYxZJEEzUBE5WoWLEgqCiKoHSQXoc+1BlgZpi58/tj3QnXwznnnrL3+a61z/v1PJ/nYnv8rrX3Pft719l7bZAkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSVIbE9EFSJIGtgVwILAXsCOwEHgcMA/YaOq/swx4GLgbuAm4DrgGOBe4FFg52pIlSZKk8TEfeBHw76RGfPWQWQqcAbyL1PxLkiRJqsBBwH+RGu5hm/ZuOR94G7DBaIYlSZIkNccs4DXAhdTbtLfLEuDTwDa1j1KSJElqgJeR7k8fdePemoeBjwML6h2uJEmSVKaFwA+Ib9xbcy9wLOlbAUmSJGnszQLeBzxEfLPeLWcBO9U0B5IkSVIRNgVOI7457zX3A6+sZSYkSZKkzB1E2ps9uinvN5Oke+PnVD8lkiRJUn4mSPeULye+GR8mPwe2rHhuJEmSpKxsCXyP+Oa7qtwMPLXSGZIkSZIy8QrgLuKb7qqzEjgBb6mRJElSQywAvk58o113fgXsXNGcSZIkSSFeAdxJfHM9qjwEHAfMrmLyJEmSpFHZGDiJ+IY6Kr8Edh96FiVJkqQReBVwB/FNdHTWrMZ7b7wkSZKytDPwfeIb59xyJfCsIeZVkiRJqtTawPHAw8Q3y7lmknRL0eaDTbEkSZJUjRcB1xHfIJeSu4A3kF5mJUmSJI3MbsB3iG+IS81vgEP6nnVJkiSpT5uQXlq0nPgmuAn5DrBDPwdAkiRJ6sUc4M00802q0XmI9EfR+j0fDUmSJKmLl5J2UoludJuem4GjgFm9HRZJkiTp9x0M/Iz4xnbccjnpDbY+6CpJkqSe7AWcQnwjO+45BzhshmMlSZKkMbY7qXGfJL55NY/mdGC/LsdNkiRJY2ZH4IvASuKbVdM+k8BXSH9kSZIkaUwtBD4LPEJ8g2p6yyrS1pOuyEuSJI2RPYGTcMW99JwOHIgkSZIaax9S476K+ObTVJdf4MOukiRJjXIw8H3iG01Tb87ERl6SJKlYs4DDSbdZRDeWZrQ5n/TW3PlIkiQpe+sDxwLXE99ImtjcBhwPbIokSZKysxA4AbiX+MbR5JVlpGcfnoAkSZLCPY308iV3lDEzZZJ0S9XhwASSJEkamfWBN5HudY5uCk2ZuQh4K7ABkiRJqs3+wOeAB4hvAEvIWcA1GdSRc5YC/4H7yUuSJFVmA9JKqavtvedu4DVT87ch8I0MaiohFwJvn5ozSZIk9elA0sroUuIbu5LyLWDLlrmcAN4FrMigvhLyIPBF4CAkSZLU1aakFdCLiG/iSstiHl117+RAvKWm31wCvAPYbIa5lSRJGhvzSbuCnAIsJ75hKzHfAbbqcb7XAU7MoObSspK0g81RpIeoJUmSxsoc4A+ALwFLiG/OSs0dwCv6nPs1/pC0ah89hhKzFPhv4IWkc1mSJKmx9iOt/t5OfBNWek4BNu9v+h9jAfC1DMZScu4hvSTq2bi3vCRJaog9gb8Hrie+2WpCbgNe2tcRmNlrcDW+itxAOtf37Gv2JUmSgs0GDgY+AlxJfFPVlEySduXZpPdD0ZctgVMzGGdTciXpd+Bg0u+EJElSVtYBXgJ8HriT+OapabkEeFrPR2M4fwTcOoIxjVPuJP1uvIT0uyJJkhRiU9KOHKfgm1HrykPA8cDc3g5JZTYkPauwcsC6Tec8TNrN5lh63zlIkiRpYAtJjcfpwCPEN0NNzneAHXo6KvXZFziP+LloalYBvyH9kbZfb4dEkiSpuw2BI4B/xRcAjSpXAy/u5eCMyFrAe0lvJ42em6bnGtLv2hGk3z1JkqQZrQU8FfgQcDauso8yS4D3A/NmPEoxtifdLhU9T+OSR0i/gx8CDiL9bkoS4J610ribDTyR9IDkwcBzgI1CKxo/q0l7sf85cFNwLb14Oun++H2iCxkzDwK/IjX1vwDOAlaEViRJkkZiLmk17zjgNHz4NDrnAk/pesTyNBs4GveOj8wDpN/h95F+p0f9oLOkQK7AS822BenifvDUz/2A+aEVCWAR8FekN3hOBtcyjE2AvwHegrd4RFsG/Bb4JWmV/lek7SslNZANvNQca5Nuh9kfOIDUsO8cWpFa3QecAHyStJ1gU+wFfBR4XnQh+j1Xkxr580i73VxEs847aWzZwEtlmgPsTWrW12RPXAXN1TLgM8DfA/cE11KnZ5H+QNk/uhC1tRK4lNTM/4bU2F9CemBWUkFs4KX8bQzsQbr95QnT/tlbYfI3CXyd9MzB9cG1jMoE8HLg74BdgmvRzFYCVwGXAZeTbsO5jHS+rg6sS1IXNvBSPrYCdgd2Ax5PatT3Ib3xVOU5jbQt5CXRhQSZA7yJdK//lsG1qH93k265uQz4HXDl1M/bIouSlNjAS6O1AbAjsBOwK6lhfzypaffFLc3wE9KbNc8KriMX6wHvIr0Mav3gWjS8+3m0mb9i6p+vm8qSwLqksWIDL1VrbWDbqewILJzKmn/eLK401czGvbvNSXvdH01q6tU8i3m0mb9+2j8vAm7GB2ilytjAS72bDWxH2tllG1KTvg3p1pftpn56u8v4ORP4a2zce7UZ8G7gz3BFftzcDdxKemHZrcAtU/+8CLhm6p9XhVUnFcQGXurs8cChwCGkh0YX4stS9KgzSSvuPw+uo1SbkG6tOYZ0a5m0grRi/xvS79VZpNt0JEnq6kDgn0lf90a/adHkmR+T/qhTNTYmfYNxL/HH1uSXm4GPAU9GkqRp1gXeQXrpSfTFyuSZVcCppDfaqh4bAR8k7ZMffbxNnrmKdOvVukiSxtaGwN+S7suMvjCZPPMQ8G+kHYM0GhsA7wFuJP74mzxzN/Bh3LlLksbKLOAo4HbiL0Qmz9xFeqPoVijKLOBw4JfEnw8mzywGjsU3UEtS4z0RuJj4C4/JM1cBbyVtB6p8PB34FulWpuhzxOSXC4G9kSQ1zizSSs0y4i82Jr/8hvStzGyUs52AE4EHiT9nTF5ZQdoVyt9hSWqIjYHTib/AmLyyDDgZeAoqzWakB169Dc605oekB6IlSQXbhbSPcPRFxeSTa4D34ltxm2A+cCTwC+LPK5NPLid9WyNJKtC+uMOMSVkJfBN4Hul2KjXPnsCngPuIP99MfO4iPfMkSSrIE0k7FERfRExsbiPtJrM9GhfzgVfgbXMmvVNgPyRJRdgTm/dxziTpbakvB+agcbYv8FlgCfHnpYnJXcAeSJKytjlwPfEXDTP63Ap8FF+6pMfaAHgbabvB6PPUjD7X4jMvkpStucDPib9YmNFlGXAK8EJ8mYt6cwDwafyWbtzyM9I1QpKUmY8Tf5Ewo8m5wNuBTZAGMxd4GekFUSuIP6dN/fknJElZeSa+pbHpuYr0opbdkKq1OelFb78m/jw39WUV6a2+UvEmoguQKrABcDHuNNJEtwFfBf4HOC+4Fo2HnYBXA6/Chx+b6HpgH9KDzZKkQP9I/MqOqS53knYOeRa+Fl2x9gb+HriO+N8LU13+DqlwrsCrdDsAvyPt/axyLQa+D/wv8APgkdhypMfYg7S//CuBxwfXouEsA3YHbowuRJLG1f8Qv5pjBstNwCeBQ/HtqCrLXsCHSLfuRf8emcFy0mOOqlQQV+BVsp2AK/E2i5JcAHx7KheQLqRSyXYBXgq8CDgYP49KsZJ07G4IrkOSxs4niV/FMd2zEvgFcBzpYik12Sak22xOAu4l/vfPdM8/tz+MUv5cgVepNgQWAetFF6LHuJF0H/sPgTOAB2LLkULMId0e9kLg+XjffI4eALbFzyhJGpk3EL96Y1IeBk4nrbLvhwsDUjtb8Ojq/N3E/96alKO6HTQpV15oVaofAM+LLmJMrSLdv/4T0gr7WaQmXlJvZgMHkD7DngM8mbRir9H7Hun5BakoNvAq0WakF/ysFV3ImFgNXAacOZWfAfeFViQ1y7qkB2CfCTwD2B8/30ZlBbAl6ZkFqRg28CrRq4AvRxfRYKtI2+P9Yio/Jb1cSdJorA8cQmrmDwX2xRX6Or0c+Hp0EVI//AtfJXpadAEN8yBwIalZP3vqp6tRUpwlwGlTgdS870367FuzUr9ZTGmN9DRs4FUYV+BVoguBfaKLKNRq4CrgPOBc4Fek+VwZWZSkvkyQdrV5Kqmh33/qX7sH/WDOJz2ALxXDBl6lWRtYim/u7NUtpGZ9TcN+HnB/aEWS6rAe8CRSM3/A1M+d8Trfi1Wk5xCWRxci9cpfbJVmT+CS6CIyNAlcA1xEWlG/mLRTzC2RRUkKtRGpkd+XdAvO3sDueD99O08AfhddhNQr74FXaXaOLiAD95J2hbmY1LBfBFxKupddkta4D/jxVNaYS7rdZk1Dv8/Uzy1GXl1edsYGXgWxgVdpdoouYIRuAa6YymXAlcDlwO2RRUkq2goe/cN/uk1Jq/OPB3ab+rk7sAPjcW/9wugCpH7YwKs0G0cXULE7gGuB66ZyLalRvwLvVZc0OneTdqE6u+XfnwfsSmrmdyE1uguBHYFtaU5zv0l0AVI/bOBVmvWiC+jTYtJK+s3ATTzapK/56W0vknK2nPTcUbtnj+YA25Oa+TWN/Q7ANqTmfkvKud++tGuLxpwNvEqzbnQBbZwD/JbUqC8iNetrmvZlgXVJUp0eIT08f02H/3wWqYnfBtiK1NRvPZVnT/1nubCBV1Fs4FWaedEFtPGPwDeji5CkzEwCt06l1U6k/dc3GGlFneV4bZE6ci9tlWYyuoA23I5VkvpzLXm98XlVdAFSP2zgVRobeElqhpwegLWBV1Fs4FWaHD9kbeAlqX859SA5XlukjnL65ZF6keOHrA28JPUvpxX4HL/dlTqygVdpcvyQtYGXpP7l1IPkuDgkdZTTL4/Uixw/ZG3gJal/Oa3A53htkTqygVdpcvyQtYGXpP7l1IPkeG2ROsrpl0fqhbfQSFIzuAIvDcgGXqVZGV1AG/4eSVL/cvrszHFxSOoop18eqRc5fsjOiS5AkgrkCrw0IBt4lSbHD9m50QVIUoHmRRcwTY7XFqkjG3iVJscPWRt4SerPXPJ6fijHa4vUkQ28SrM8uoA2vIVGkvqT0+o7wLLoAqR+2MCrNDl+yLoCL0n9sYGXhmADr9Lk+CFrAy9J/cntczPHa4vUkQ28SvNwdAFteAuNJPUntxX4HK8tUkc28CpNjqskua0kSVLucmvgc7y2SB3ZwKs0OX7IugIvSf2xgZeGYAOv0uT4Nefa0QVIUmFs4KUh2MCrNDl+yK4TXYAkFSa3z80cF4ekjmzgVRobeEkq33rRBbTI8doidWQDr9Lk+CG7bnQBklQYG3hpCDbwKk2OH7KuwEtSf2zgpSGsFV2A1KeHogtowxV4jdq6wI7AtsCmwGZTPzfk0YcDN5r6ed/Uz+XA/cDdwOKpnzcD1wMPjqRq6VG5fW56D7yKYgOv0iyJLqANV+BVl42BJwJ7AXsDe5Ia9wUV///cSWrkLwUuBi4BLgTurfj/R1ojtxX4HK8tUkc28CpNjh+yua0kqVzbA88ADp7K44GJEfz/LpjKgdP+vdXA74Czp/JT4MYR1KLxkFMDPwksjS5CkpruIVJzkUtur3e4arDZwGHAR0mr39Hn8ky5dKrWw6Zqlwb1SeLP5zW5v+axSpJIDXP0B/705PitgPI1C3g68C+kW1eiz99Bc+fUGJ6OGyKof18g/hxek5trHqskCbiK+A/86ZnE29E0s22ADwE3EX/OVp2bgONJD9VKvfhf4s/bNbm85rFKkoDfEP+B35pNah2xSvZs4NvASuLP07qzEvju1Jilbk4n/nxdk3NqHqskCTiT+A/81iysdcQqzRzgdcAFxJ+bUbkQOHJqLqRWOS3E/KjmsUqV875FlSjHe843jC5AWZgFvIL0lfzJpC0gx9U+wEnANcCb8TYz/b6NowuYxodYVRwbeJXogegC2rCBH28TPNq4nwLsHFtOVrYDPkvaweYVjGZbTOVvo5n/KyOT46KQ1JUNvEpkA6+cPIm0R/opwG6xpWRtN9IcnQM8JbgWxZogr89MV+BVHBt4lSjHBj6n1SSNxsbA50j38h4aXEtJnkx6MdTnyOs2Co3O+uT1HgFX4FUcG3iVKMfVkpxWk1S/NbfLvAk/RwcxizR3l5PmUuMltz/ccrymSF154VGJ7o4uoA0b+PGwADiVdCvIlsG1NMGWpLn8JrBFcC0andy+sczxmiJ1ZQOvEi2OLqCNTaMLUO3+ALgYeGl0IQ30EuAi0hyr+XJbgc/xmiJ1ZQOvEuX4YbtZdAGqzTzgU6QXFLlKXJ8tSHP8SdKcq7k2jy6ghSvwKo4NvEqU44etDXwzbU3aYebPcPvDUZgA3gH8EtghthTVKLc/hO+KLkDqlw28SuQKvEbhGcD5uOVhhH2BX5OOgZont8/Le6ILkPplA68S3UN6/XVOvAe+Wf6E9Hr1BdGFjLEFwOnAW6MLUeVy+r1aCdwbXYTULxt4lWglcF90ES1yW1HSYCaA44EvAHNiSxGwFvCvwIl4vWqSnBr4HBeEpBn5gahS5XYf/HrA/OgiNJS1gP8CPhRdiB7jGNKxWSu6EFUip4dYc7uWSD2xgVepvA9eVZoLfAU4MroQdfQ60h78/qFcvpxW4HO8lkgzsoFXqXL80LWBL9PapBcJ/WF0IZrRi0jHap3oQjQUV+ClIdnAq1Q5fuj6Zs7yzAW+DrwguhD17HnAN3Cv+FLNIa8XOeV4LZFmZAOvUt0eXUAbNvBlmQ2cjM17iZ4HfBXviS/RluTVe9wWXYA0iJx+iaR+5Pih+7joAtSzCdJDka+MLkQDewnwn/iCrdJsFV1AixwXg6QZ2cCrVDbwGsbfAa+NLkJDey3wt9FFqC9bRxfQ4tboAqRB2MCrVDbwGtQbgb+ILkKV+UvgbdFFqGe5rcDneC2RZmQDr1Ll+KFrA5+/ZwH/Fl2EKvdJ0rFV/nL7nMzxWiLNyAZepcrxa08fYs3btsCX8cHHJloLOAXYMboQzSinW2hW4z3wKpQNvEr1EPBAdBEtcltZ0qPmk7aLzGn/aVVrE9L2kmtHF6KucrqF5m5geXQR0iBs4FWy3Fbh1wE2jC5CbX0cOCC6CNXuicDHootQVzk18K6+q1g28CpZjvcubhtdgB7jxcBbo4vQyLyNdMyVp5xuocltEUjqmQ28SpZjA79ddAH6PQuAz0UXoZH7PN7SlqMNgY2ii5jGBl7FsoFXyWzgNZMvAFtEF6GR2wz4j+gi9BjbRxfQwltoVCwbeJVsUXQBbXgLTT5eA7wwuogAjwD3AjdM5V5gZWA9Uf6AdA4oHztEF9Aix2uI1BO3U1PJbowuoA1X4POwGfCJ6CJq9DBwDnAxcOVUrgLuBFZ0+N/MI+3CsxuwK7A7sDfwFNIuPU30CeBHwOLoQgTktwKf4zVE6okNvEqW44evDXwe/onmbRn5W+A04ExS876sz//9ctKK4yLgjGn//nzgIOAw0qr1vkNXmo/NgY8CfxJdiAAbeEkSsCnpRRw55bpaR6xe7AesIv5cqCK3ACeStkcclccDxwPXVzSG6EwCT65ygjSwrxF/PkzPBvUOV5LUyQPEXwSmZwU+WxJpAvgV8efBsDkPOILYc2kW8Ieklf/o+Rg2vySdG4p1HvHnwprcU/NYJUldXEL8haA129Q6YnXzOuKP/zD5OfC8ymdleC8AziZ+fobJayufFfXrTuLPgzU5v+axSpK6+B7xF4LWHFrriNXJHOAa4o//ILkNOIr8V4kPB24mfr4GyfXA3OqnRD1aj/hzYHpOrXe4Ur38ql+luyG6gDZ2ji5gTP0JsFN0EX1aBXyStDPMSaTGImffAfYCPk26t7wkOwCvjy5ijO0SXUALH2BV0WzgVbocP4RLayKbYB7w/6KL6NNtwLOBY0nPcpTiPuAdwHMp70U4/490rmj0clvYyPHaIfXMBl6luym6gDYWRhcwho6irJdo/YS0W85Pg+sYxhmkfeR/GF1IH7YDjowuYky5Ai9J+j9PIf5eytacW+uI1WoCuJz4495r/pFmLZ7MBj5G/Lz2msvJ/1mDJvo88cd+evard7iSpG4WEH8haM3dtY5YrV5E/DHvJZPAe2uagxwcSzn77x9e0xyos58Rf9ynZ+N6hytJmsl9xF8MvDjEOZ344z1TVpC2uGy6o4BHiJ/vmTL9TbQajVuIP+5rclfNY5Uk9eA3xF8QWrN/rSPWGjuRVrajj3e3TDJee5AfSRnHJLeHKptsHfI6J35Z73Cl+jXpPkyNr6ujC2hj1+gCxsSfkv/9zO8G/ju6iBE6mfxvFZognTsajZ3J6/c0x2uG1BcbeDVBjh/Gu0UXMAbmkPZ+z9kJwCeiiwjwMeCfoouYwR+TziHV7/HRBbTI8Zoh9cUGXk2Q44exDXz9ngNsEV1EFz8APhBdRKDjgB9FF9HFFqR9+FW/J0QX0OKq6AKkYdnAqwlybOB3jy5gDPxRdAFd3EJ6oLO0t5VWaZJ0P/yt0YV0kfM51CSuwEuSHmNT4h+Kas1D+AdyneaR5+5Dq4GVwGH1Db04TyfNSfRxaZf7gfn1DV1TLiX+WE/P+vUOV5LUq3uIvyi0Zoc6BzzmXkj88e2Uj9Y47lJ9nPjj0ikvqnHcgrWAZcQf5zW5rd7hSqPhCqGaIsevRL0Pvj5/EF1AB4uAv44uIkMfJN1WlKMXRBfQcDuRvjHLRY7XCqlvNvBqihw/lL0Pvj65Nl3vBJZGF5GhJcCfRxfRQa7nUlN4/7tUAxt4NcXl0QW0kdvOC02xO7BjdBFtnAl8PbqIjH0FOCu6iDZ2xD+265RbA/+76AKkKtjAqylybOD3ii6goZ4VXUAHfxNdQAE+HF1ABz50XJ+9owtocWl0AVIVbODVFJdFF9DGnuT19sGmODi6gDbOAX4WXUQBfkyer7HP8Zxqin2iC2iR47VCksbWLNLWjdE7HLRmhxrHPK5uJP64tsb7qHt3OPHHqzU31DngMTYfeIT447smD+CiiiRl57fEXyBa8+JaRzx+tib+mLbmamwK+jEBXEv8cWvNNnUOekztS/xxnZ5z6h2uNDreQqMmyfE++D2jC2iYfaMLaONkUnOg3qwmzVlucjy3SvfE6AJaePuMGsMGXk2S44ezD7JWK7cH4lYDX4ouokA5/tGT27nVBLnNaY7XCGkgNvBqkhx3F7CBr1Zu8/kL4LroIgp0LfCr6CJa5NZsNkFuv685fksrDcQGXk2S4+rKrqQHuVSN3G5J+l50AQXLbe72iC6ggdyBRqqJDbya5EbgwegiWswhv1WoUk2Q3wuczowuoGA/iS6gxUJ8GLlK2wObRhcxzQPAougipKrYwKtJJslzhcWH46qxAFgnuohp7gfOjy6iYOeRmqpczAe2jC6iQfaLLqDFJeT33IU0MBt4Nc0F0QW0YQNfjdxW388CVkUXUbCVwM+ji2iR2zlWsv2jC2hxYXQBUpVs4NU0NvDNtW10AS0uii6gAXKbw9zOsZLltgKf47VBGpgNvJomxw/pvUj3wms4m0cX0OLK6AIa4KroAlpsFl1AQ0yQXwP/2+gCpCrZwKtpLiZ9NZ+TebjDRRVya65s4IeX2xzmdo6VakfyeoB1BW4hqYaxgVfTLAOuiC6ijSdFF9AAm0QX0CK31eMS5dbA59R0liy31ffLSE281Bg28GqiHG+jye2BrhJtGF3ANMtJu9BoOPeSV2OV0zlWstw+73K8JkhDsYFXE+W428CB0QU0wNzoAqZZEl1AgyyNLmCanM6xkj0luoAWbveqxrGBVxPluNqyN3ntYV6iedEFTGMDX52c5jKnc6xUa5HfLTQ5XhOkodjAq4kuIL8XdszB++CHldPqaE6rxqWzgW+WfYB1o4uYZpK0uYHUKDbwaqL7gOuji2jD22iGk9Nr7nP7A7Fkk9EFTJPTOVaq3D7nrsI/uNVANvBqqnOjC2gjt/tCS5PTw47rRRfQIBtEFzDN8ugCGuCp0QW0+HV0AVIdbODVVDl+aOe2MlWanBr49aMLaJCc5tIGfngHRRfQIsdrgTQ0G3g1VY4f2tsBW0UXUbCcmitX4KtjA6FdNZEAACAASURBVN8cC4CF0UW0yPFaIA3NBl5NdQF5rdiukdvqVEkejC5gmrXJ60G9Uq2PDyc3SW63CT4MXBJdhFQHG3g11TLgougi2jg4uoCC3RVdQItdowtogN2iC2iR2zlWmkOjC2jxW+CR6CKkOtjAq8ly/Or0adEFFOzu6AJa5NZ8lii3ObSBH05uDXyO1wCpEjbwarIcP7yfhPdPD2pxdAEtcms+S5Tbtxi5/ZFYkvXJ710XOe5GJlXCBl5NlmMDvxbeBz+o26ILaLFXdAENkNscLoouoGBPJX2+5STHa4BUCRt4Ndk15LdqC94HP6jcXs71DPwMHcYs4JDoIlpcF11AwXK7feY24MboIqS6ePFRk60mz69Qc2taSrGIvB5I2xTYM7qIgu0DbBZdxDQPk9+3PCXJrYF39V2NZgOvpvt5dAFtHAjMiS6iQKuAm6KLaHFYdAEFy23ubiD90a/+rQ0cEF1Eixw/+6XK2MCr6XL8EF8XeHJ0EYW6MrqAFi+ILqBgz48uoMVl0QUU7CBgXnQRLXL87JcqYwOvpjsPeCi6iDZyW30sRW57+z8b2Dq6iAJtBTwzuogWuZ1bJXlWdAEtlpJe5ic1lg28mm4FqYnPTW7NSykuji6gxSzg1dFFFOh1wOzoIlrYwA/u2dEFtDgbWBldhFQnG3iNg7OiC2jjINJ9o+pPjk3WkdEFFCjHOcvx3CrBRsB+0UW0+EV0AVLdbOA1DnK8F3I+ad9k9edK4P7oIlrsjW/Y7ceh5Ld7zyLye0C6FE8nv29Tcly0kSplA69x8Cvy2n5wDW+j6d8k8MvoItr4QHQBBclxrmz4Bpfb7TPLyXP7YKlSNvAaB0uBC6OLaMMHWQdzdnQBbTwf2D+6iAI8GXhudBFt5PgtXSlya+DPBZZFFyHVzQZe4yLHFbYDgA2jiyhQjscS8lxZzs1fRRfQwc+iCyjU1sDu0UW08I8xSWqQw0kvacktL6tz0A01B7iP+GPXLrmtRubkecQfn3a5rs5BN9yfEn/8WpPjNzySpAGtT9pSMvri0prP1jnoBvtf4o9du1xFfi+0ycE84Arij0+7fKrGcTfdt4g/ftOznPSiPKnxvIVG42IJee4H75s8B/P96AI62AV4T3QRGToO2C26iA5Oiy6gUPPI7zmes4EHo4uQJFXrr4lfIWqX3O4hLcEWpBe1RB+7dnmYtLWkkieR5iT6uLTLvaQtXdW/5xN//FrjcygaG67Aa5ycEV1AB8+LLqBAdwA/jS6ig/nA14ANogvJwHrA/5Bvk/wN3LFkUC+KLqCNH0cXIEmq3lzSrTTRq0St8Sv8weT4AN30fKW+oRfjS8Qfh27xoePBXU/88Zuee8nvhVKSpIqcRvyFpjUPAWvXOeiG2oT00Fr08euWd9Y2+vy9h/j575bbsOEb1B7EH7/WnFrriKXMeAuNxk2Ot9GsTX4Pg5XgHuA70UXM4J+B10cXEeDVwEeii5jBF4FV0UUU6vDoAtrI8bNdklSRfYhfKWqXf6tz0A32HOKP3UxZQXrgb1wcRrqvPHreu2US2LmuCRgDPyf+GLbGzQAkqcEmgNuJv9i0ZtFUberPBHA18cdvpixhPO63fi6wlPj5nik/rGsCxsAmwCPEH8PpubnWEUsZ8hYajZtcL95bA/tGF1Gg1ZTxMqz1gO8Br4oupEavId3SVMKLdD4dXUDBng+sFV1Eix9EFyBJqt+riF8xapcP1TnoBtsQuI/449dLVgHH1DMNod5FGlv0/PaSy/DbrmH8N/HHsDVH1DpiSVIWNia/r4BXA7+pc9AN94/EH79+chJpVb5065H/VpGteX0tMzEeZgOLiT+G07McWL/OQUuS8pHjQ1iTpFtp1L+tyP/BydZcDuxZx2SMyN7AFcTPYz+5ifQ+CA3mUOKPYWt8eZPGkvfAa1zl+PKkCeBl0UUU6lbgP6KL6NPjgXOB9wFzgmvpx1zg/cA5wG7BtfTrw6RdgTSYl0YX0EaOn+WSpJrkup3kWXUOuuEeRxk7oLTLlaQtMXP3dOBS4udrkFxFWX8o5WYWabes6OPYGrePlKQxMkHaeiz64tOaVaTbQTSYfyD+GA6aSeCrwF6Vz8rw9gG+RvwcDZNXVz4r4+VpxB/D1lxb64glSVn6HPEXoHZ5R52DbriNgbuIP4bDZBL4JnBAxXMziCcD3yLVFD0vw+TXeMvosD5F/HFszadqHbEkKUtHEH8BahdvoxnOW4g/hlXlMuA4YEGlM9TdxsCbgV9QfuO+emoMB1Y6Q+NnFuk5k+hj2ZoX1DloSVKe1gUeIv4i1JpVpPu5NZhZwG+JP45VZjlpJfwtwC7VTdX/2RV4K/Bt0kOe0eOtMl+ocJ7G1WHEH8fWLAHm1zloSVK+vkX8hahd/qzOQY+BgyjnxUKD5Gbgv4D3AoeTGvBe3o45Z+q/++Kp/+1J5PksSFW5G9iih3lRd58l/li25n9rHbEkKWt/QvyFqF1+Vuegx8QniD+Oo8wK0v3/1wLnk9518POpf7526j9r2ur6THk9GtYc8nyu5DV1DlqSlLdNyfOtrO5GM7x1gKuJP5YmJj8m7Tal4byA+GPZmhXARnUOWsqdT+Vr3N1NelgvN7NID9lqcA8BbyI9xKjxcj/wRlKzp+G8MrqANs4E7osuQopkAy+lLfty9IroAhrgp8BHoovQyB0N3BhdRAPMBV4SXUQbp0YXIEmKtz15bpfnbTTVWAs4m/jjaUaTL6KqvJj449kad+mScAVegrRSd0F0EW3MAl4aXUQDrAReB9wbXYhqdyVwTHQRDZLj7TPnArdFFyFFs4GXkly/kv2j6AIa4nrSrhWrogtRbZYAL5v6qeGtTVqBz02un9WSpAC7Ef/VcLtMAjvVOO5x8z7ij6mp5/fEZ0aq9Vrij2u77FznoCVJ5bmQ+ItTu/x1nYMeMxPAl4g/pqba/C2q2o+JP66tObfWEUuSivSXxF+g2uUGvN2tSnOAHxJ/XE01+Qru9161HcjzTcbvqXHMkqRCLSTP3WhWA4fVOO5xtD7pDaXRx9UMl7OAeahqf0P8sW3NJGnHMEmSHuNc4i9U7XJSnYMeU4/DN7WWnIuAjR9zVDWsWaSduaKPb2tyfOGeFMav5aXf99XoAjp4ObBhdBENcxvwTODa6ELUt2uA5+PWoHV4DrBddBFtfCW6AElSvrYl39to3ljjuMfZtqQmPvr4mt5yE+kebdXjq8Qf49b4UjuphSvw0u+7GfhldBEd/HF0AQ20BekPo02iC1HPNgbehQ1dHTYFXhJdRBs/BW6NLkKSlLd3EL/i1C6TwC41jnuc7A58HlhO/HE1g+Uh4ETSNyiqxjHEH9d2eUudg5YkNcMCYAXxF612+bsaxz0OdibdIpDjFnlmsCwHPgNsjoaV47swluE3ZJKkHn2H+AtXuywCZtc47qbaFDiB1AxEH0NTT5YAxwNro0HsT/wxbJev1zloSVKzvIL4C1enPLfGcTfNPNILuu4n/riZ0eQG4NX4cqd+/Qvxx65dXlrnoCVJzTKftEVd9MWrXb5c47ib5FDgd8QfLxOTHwE7ol6sTZ6fd4uBuTWOW5LUQJ8l/gLWLsuBLWscd+k2Ij3c6H3u5iHgOLztbCZvIP5Ytcun6hy0JKmZDib+AtYpf1XjuEv2EtILmqKPj8krvwaegDq5gPhj1C4H1jloSVIzTZDe+Bh9EWuXW4E59Q29OPNJq+65voTLxOdh4FjU6unEH5t2uQqfY5AkDeh44i9knfLK+oZdlN3JdwXR5Jevk14GpeRrxB+TdvlAnYOWJDXbQvJd1f1ZjeMuxVHAUuKPhSkr1wEHoO2AR4g/Hq1ZBWxf47glSWPgx8Rf0Dpl7xrHnbMJ8v52xOSfZaQ/AMfZPxJ/HNrl+3UOWpI0Hl5F/AWtUz5b47hztR7wTeLn3jQjJwKzGD/rkLZpjJ7/dnlZjeOWJI2JecBdxF/U2mUp43U/70LgMuLn3TQr3wDWZby8ifh5b5fb8QF9aUbjuOog9Ws5cHJ0ER2sC/xJdBEjsidwNm4HqOodAfwE2CS6kBGZAI6JLqKD/yTdly9J0tB2J9+HWa+h+X+M70e+34KY5uRyYGua71nEz3W7TAK71DhuSdIYOpv4C1yn/EGN4452CHA/8XNsxiPXkW7VarJvET/P7XJmnYOWJI2nPyb+Atcpp9U37FDPBh4ifn7NeOUmYGeaaSGwkvg5bpfX1DhuSdKYWhe4j/iLXLusIt3m0yQHAkuIn1sznrke2Ibm+Tjxc9sui0lvVJbUg6bfNytV6UHgv6KL6GAW8N7oIiq0J+lbhfWiC9HY2oF0S8cWwXVUaVPgT6OL6ODzpL35JUmq3C6k1e7o1ap2WUF6s2LpFgK3ED+fxqwGLgQ2ohn+hvj5bJdVwI41jluSJH5E/AWvU/65xnGPwibA1cTPozHTcybl702+AXAP8XPZLt+pcdySJAHwEuIveJ2yFNisvqHXajbptpnoOTSmXb5A2d5P/Bx2yvNqHLckSUC63/w64i96nfKh+oZeq1wfrjNmTY6mTPOBW4mfv3a5Gp/HkySNyHHEX/g65W7Ke/jzSOLnzZiZ8ghwGOX5M+LnrlOOrXHckiT9ns2Ah4m/+HXKO+sbeuWeRNp9InrOjOkliynrYfE5wI3Ez1u7LKU5DwhLI+XXVtJgFgNfjS6ii3dTxkN36wD/A8yLLkTq0abAl0jPbJTgdeT7B8d/k96tIUnSyOwFTBK/itUpr69v6JX5LPHzZMwg+SvyNwu4gvi5apdJ4An1DV1qtonoAqTCnUG+98T+jvRCpMnoQjo4AvhGdBGBVpNWHx8k7eFfkg1I356sE11IoJXAocCvogvp4pXk+03hacALo4uQSmUDLw3nhcB3o4vo4gjgm9FFtLElcCnpdoQmuwE4B7gSuGYq1wP305y3Tm4ELAB2AnYmvexsL+DJNL/Bvx7YB1gSXUgbE8D5wBOjC+ng2aQFEEmSRm4CuJz4r6M75Tfk+Yf6l4mfmzpyG/CvwKuBrSubrTLNAZ4C/Dnp5WePEH986siJVU1YxQ4nfm465YIaxy1JUk/eRPwFsVuOqG/oA3ku8XNSZe4E/gV4BuU82BhhM+DNwOnAKuKPW1VZCexf4TxVYRZwIfFz0ylH1jd0SZJ6Mw+4nfiLYqdcSj47Ts0j34fq+s2FpIZ07UpnaDzsCJwA3EP8cazqXFir0hkazmuJn5NOuQWYW9/QJUnq3fHEXxi75TW1jbw/HyZ+LobNT8j3weXSbAC8C7iD+OM6bHJ598Ic0rMW0fPRKe+vb+iSJPVnAXm/2Okq4lcItyPvOZopvwNeXPmsCFIj/3ekHXmij/OguR/YvOqJGcDbiJ+LTlkCbFzf0CVJ6t9niL9Adssb6ht6T75I/BwM2nQcQxkvxirdNsBXiD/mg+YT1U9JX9Yh3aISPQ+d8rH6hi5J0mC2I+3nHX2R7JQbiHvj6e6UuQvJ2aRtETVaLwJuJf7495vlwMIa5qNX7+9QVw5ZhjszSZIydRLxF8pueXt9Q+/qm33UmEOWA+8mn4d/x9ECyjtvVpM+AyJsBNzdY40R+Vx9Q5ckaThPIO8t8m5l9LumPKWi2keVO4Cn1TIT6tcE8AHy/p1qzSrSi6xG7W8HrHcUWUl6yZckSdk6lfgLZre8p76ht5X7fEzPRcAOtcyChvEC4F7iz49ec3I909DRAuCBimqvI1+ub+iSJFXjAOIvmN1yF7B+baP/fTuTVt+ix9xLfgCsW880qAJ7UM598SuAbeuZhrY+VdM4qsgksE99Q5ckqTqnE3/h7JYP1jf035NzYzE93yXuAV/1blfgZuLPl17y0ZrmoNVC0jMb0ePt9rslSVIRnkH8hbNblgBb1TX4KZsASzMY60w5Fd8MWZKFpB2Vos+bmXIfaX/7un0taHy95qn1DV2SpOr9hPiLZ7d8ob6hA/C+DMY4U87A/d1LtDPpVrDo82em1P121mdkMMZu+WFtI5ckqSZPI/4C2i2rgP1rG316c2n0GLvld/hWyJIdTP5v9r20ttHDbODCDMbYLe7mJEkq0pnEX0S75RekrfqqdmAGY+uWxfiCpiZ4BekhyejzqVv2rWnsb8tgbN1yWk3jliSpdocQfyGdKUfUMO7PZDCuTlkFPLuGMSvGR4g/p7rlxBrGvBFwZwZj65Yn1zBuSZJG5gziL6bdci3V7sAyl7TCHT2uThnV7iAajTnAucSfV52ymOofkv5EBuPqFneekSQVL/d74VdT7cudXprBeDrlfNwusol2Bx4k/vzqlBdXPNYVGYypUyZJ78KQJKl4PyL+wtot9wKbVTTWz2cwnnZZQXoZkJrpGOLPsU759wrH+f0MxtMt365wrJIkhdqf/B+2+0wF45wF3JbBWNrlnyoYn/I1G7iI+POsXW6lmofFX5TBWLplFfDECsYpSVI2cn/hykpgzyHHeEAG42iXO4ANhxyb8vdM4s+1TtlvyLHNBa7IYBzdcvKQY5QkKTu7A48Qf5Htlh8NOcbjMxhDu7xhyHGpHLn+ofyhIcf13gzG0C0rSG/JlSSpcf6D+AvtTHnVEOP7dQb1t+Zq0u0VGg97kOftar8eYkw7AEszGEO3VHELniRJWdoaeIj4i2233EbaZ7pf65DnNwxvGmAsKtt3iD/vWvMIsG6DxjM9S4EtBxybJElF+CfiL7gz5VMDjOvpGdTdmtuA+QOMRWXLdevWQwcYy6szqHum/O0A45IkqSibAvcRf9HtlpX0v5fz+zKouzXv63MMao5ziD//WnNcn2PYGLg9g7q75W4G+8ZOkqTivJ/4C+9MuQhYq48xnZpBzdOzEr/WH2dvI/4cbM2pfY7h3zOoeaa8s88xSZJUrPnADcRffGfKMX2M6dYM6p2e7/dRu5pnM/J7Y+ltfdR/CHk+jDs9V5O2t5QkaWy8hvgL8Ex5gPTg7UwWZFBra17dQ91qthwf/lzQQ91zgcsyqHWmHNHDWCRJapQJ8tx2sTWn9DCWgzOoc3oeJO2Ko/H2OuLPxdYc0kPdH8ygzplyVg/jkCSpkQ4i/6/JVwMvnGEcb8igxun5wQz1ajw8jvhzsTVvnKHmXYGHM6izWybp/yF3SRWaFV2ANOZ+BXw9uogefJLue1jvMqpCenRGdAHKwm3AldFFtNi1y382i/Tgau5bn/43cF50EZIkRdoJWE78qtpM6bY3fG6vr39Sl1o1Xv6N+PNxer7ZpdZ3ZVDfTHkI2LbLGCRJGhsnEH9hnimrgGd0qP+iDOpbk3vw20U96rXEn5PTc1mHOncn/7c0rwaO7z7dkiSNj/WARcRfnGfK9cD6beq/P4Pa1uRnPcy3xseTiD8np+dB0gPs061FGQ+030T3W+kkSRo7ua0UdsqnW+reJIOapudfepxvjYd1ye9B8c1baixh15nVwB/2NuWSJI2PCeCnxF+kZ8ok8Nxpde+bQU3T8/aeZ1zj4ibiz8vpmb6DyxMp4xkYHwyXMuJ9olI+VpNeS74qupAZTJAeDFxv6l9vH1hLO5dHF6DsXBFdQIsdpn7OA04m/7eZrqS/tzJLqpkNvJSXC4HPRRfRgx2Bj0z755xcF12AsnNjdAEtdpj6+WFgz8A6evVpOj98K0mSSPeULyb+K/OZMgkcBpyYQS1rsgqY0/+Uq+Fyu8f8M6S3F6/MoJaZcgewUf9TLqlOrsBL+bkHeF90ET2YAD4P7BVdyDS3A49EF6Hs3BRdQIs9gP8EZgfX0Ys/B+6LLkKSpBJMAGcSv/pWWn45yGSr8Z5F/LlZYn7KY7e8lJQBV+ClPK0G3oGryf26OboAZSm3FfgSLAfeSvoskpQZG3gpX5cBH4suojA28GrnZmxE+3UC+e3eI0lSEdYGriX+q/RScuxg06wxcCfx52cpuQqYP9g0SxoFV+ClvD2MLybqh7dKqBO/nend0cCy6CIkdWYDL+XvB8Ap0UUUYlF0AcqWf9z15mTgx9FFSOrOBl4qw9uBu6KLKEBuL+xRPlyBn9li4D3RRUiamQ28VIbFpP2Y1dly/CNHndnAz+xo/B2SimADL5XjJODb0UVkzJ1G1I0NfHffBf43ughJvbGBl8pyNHB/dBGZskFTN94D39n9pD3fJRXCBl4qyy3AB6KLyJQNmrrxD7zO3k36bJFUCBt4qTz/Cvw8uogMuQONurkVWBldRIZ+DHwxughJ/bGBl8ozCbweWBJdSGZcgVc3q0hNvB71APBGfHZEKo4NvFSm64H3RxeRGRt4zcTbaH7fO/H3RiqSDbxUrn8lveRJic2ZZuI58qjv4q0zUrFs4KVyrQb+FLg3upBM2JxpJq42J3cDb4ouQtLgbOClst2Cb06EtA3eA9FFKHv+kZe8Hbg9ughJg7OBl8r3ReA70UUEszFTLzxP4BTgq9FFSBqODbzUDG9kvFfUvDVCvRj38+QW0svgJBXOBl5qhruAP2Z8t4NzZVW9GOfzZM32s3dHFyJpeDbwUnP8EPhMdBFBxrkxU+8WAw9FFxHkY8AZ0UVIkqTHmg9cRFqJH6ccWcXkaSxcSfz5OupcQvpskNQQrsBLzbIMeM3Uz3HiCrx6NW73wY/rZ4LUaDbwUvNcBvxldBEjtii6ABVj3P7Yew9pBV6SJGVuAvgG8V/djyKTwLxqpk1j4Hjiz9lR5VukzwJJDeMKvNRMq4E3ANdHFzICdwDLo4tQMcZlBf4a4CjSZ4GkhrGBl5rrPuCPaH5zOy4NmaoxDufLMtLv/v3RhUiqhw281GznAe+NLqJm4/ZQooYzDg38McD50UVIkqThfIn4+3HryscrnCc137rEn7N15svVTZWkXLkCL42HtwJXRBdRk3FYUVV1HgTuiS6iJlcBb44uQlL9bOCl8bAUeCXNfAult9CoX038o+9B4GXAkuhCJNXPBl4aH5cA74wuogZNbMZUryaeM28nvQNCkiQ10H8Sf59uldmq0tnROPgM8edtlflctdMjSZJysy5ppS666agiK/CbRPXv/cSfu1XlYmCdaqdHUu688Enj50HgCJpxr+wi0ptYpX405RaaJj/bIqkLG3hpPF0F/ClpBa9ki6ILUJGa8ODzJHAkzd1dSpIkdfBh4m8BGCZfqn5KNAZ2IP7cHTb/r+pJkSRJZZgAvkF8MzJoPlL9lGgMzCOtYEefv4Pmq6TfXUmSNKbWAy4ivikZJPcCB1Q/JWqwCeDTxJ+7g+YC0oPokiRpzG0P3EF8czJoE//k6qdEDVR68347sG3lsyJJkop1MLCM+CbFJl51mAA+Rfy5OmhWAIdWPiuSJKl4f0x8ozJo7gMOrHxG1ASlN++rSbtGSZIktfVJ4psVm3hVZYKyz+nVwMcqnxVJktQos4HTiG9abOI1rAngROLPyWHyI2CtqidGkiQ1zybA1cQ3L8M08U+tfFZUkibcNnMFsFHVEyNJkprr8aSHQ6ObmEGzFHhu5bOiEswGvkj8OThM7gF2q3piJElS8x0KPEx8MzNolgOvqHxWlLO5wCnEn3vD5GHgkKonRpIkjY9XAquIb2oGzUrcwWNcrAN8n/hzbpisAl5e9cRIkqTxczTxjc0wmQT+vPJZUU7WA35M/Lk2bI6temIkSdL4+hjxzc2wOaHyWVEONgbOIf78Gjb/UPXESJKk8TYL+DLxTc6w+TTpIUc1wzbAZcSfV8PmZNLOOZIkSZWaS9qXOrrZGTanku6XVtn2AG4k/nwaNmcC8yqeG0mSpP+zAXAB8U3PsPk1sKDiudHoPJOytzldk4txr3dJkjQCWwE3EN/8DJtrgV2rnRqNwMspe3vTNbkeeFzFcyNJktTRE0gvm4lugobNYuDgiudG9TmWsrc1nX7e7V7x3EiSJM3oEOBB4puhYfMg8JKK50bVmk16ADn6XKkiS4CDqp0eSZKk3j0XWEZ8UzRsVgLvqnhuVI31gW8Tf45UkYdI9+9LkiSFej7NaOJXA/9B2m1HedgG+C3x50UVWQ68qNrpkSRJGtzLgEeIb5KqyNnAFtVOjwZwEHA78edDFVkJvLLa6ZEkSRreUTTjAcPVwM3AvtVOj/rwapqx08xq0u/Ea6udHkmSpOq8AZgkvmmqIkuAl1Y7PZrBBHA88ce+qkwCb6lygiRJkurwHuIbp6qyCvgAvuZ+FDYGvkv8Ma8y76h0hiRJkmr0QeKbpyrzXVKDqXrsA1xD/HGuMn9R6QxJkiSNwN8T30RVmauBvSqdIUG6P7wJ7xOYnr+udIYkSZJG6J+Jb6aqzFLSA5Ya3lya83Km6TmhykmSJEmK8A/EN1VV5xPAnConacxsTdquM/o4Vh1X3iVJUmMcR3xzVXXOBRZWOUlj4lnAbcQfv6rzwSonSZIkKQfvJb7Jqjr3A39U5SQ12FqkLSKb8q6ANZkE3l3dNEmSJOXlaJqzT/z0nASsU+E8Nc12wC+IP051NO/HVDhPkiRJWXozzVuFXQ1cCuxR4Tw1xUuAu4k/PnU070dXOE+SJElZeyPNbOIfIL2NVrAu8G/EH5M6shI4srqpkiRJKsOrgEeIb8bqyDeAzaqbquIcAFxB/HGoq3l/XXVTJUmSVJZXAsuJb8rqyK3A86qbqiKsBXyI5v5htgx4aWWzJUmSVKjnAEuIb87qyCTwSWDtymYrX7sA5xA/53XlPuCZlc2WJElS4fYD7iC+Sasr1wJPr2y28jJBejC5qX+ErSbtW/+kqiZMkiSpKRYCVxPfrNWVSeCzpIc7m2Ih8BPi57bOXEf6dkGSJEltbAmcT3zTVmeasBo/i7TqvpT4+awzvwEWVDRnkiRJjbUhzV/VXQV8Ali/ojkbpScCvyJ+DuvO6ZR5fCRJkkLMA75KfBNXd24Fjqpozuq2LnACzd1hZnq+AcyvZtokSZLGx2zgX4hv5kaRM4Ddqpm2WhwO3ET8PI0inyLdIiRJkqQB/QXpAdDoxq7uPDg11rnV4HTRAAAABiBJREFUTFsldiPdShI9N6PIKuC91UybJEmS/pDU4EY3eaPIVcCzq5m2ga0NHE96cVH0fIwiS/EFTZIkSZU7gHTPeHSzN4pMAl8ENq9k5vpzOGnrxOg5GFUWAftWMnOSJEl6jK2B3xLf9I0qS0gr4aN4oHIP4HsjHFsOuQjYrorJkyRJUmfrAd8kvvkbZW4i7VYzUcH8tdqG9IKplRmMc5T5Hm4TKUmSNDKzSVsaRjeBo865wCEVzB+kP4SOBx7OYFyjzom404wkSVKItzAe+5JPzyRpj/yFA87ZfOCdwOIMxjLqLAfeMOC8SZIkqSLPBO4kvjkcdVaQbn3Ztsd5mg+8g/TQZnTtEbkdOLTHuZIkSVLNtgHOIb5JjMhyUiO/VYe5mQu8mfFt3FeTHnzevsP8SJIkKch80taL0c1iVB4EPgY8bmo+NgKOY3y23uyUzwHzkCRJUraOJq1KRzeOUXkYOBV4IINaIrMMeBOSJEkqwsG48jzOWQQ8BUmSJBVlc+AnxDeTZrT5ObAlkiT9//bu5uXyMY7j+NvMUMaglJkkahbKUiGJJKaUEmL+AIWNhX9hlrbsbGdJimbraRbjYYiUQtloSiaMMZHGbe4sfqTGPM8593Wfc16v+mzP+Z3r2nw6Xb/vBSykq6pXGl8qZf5Zb3oH4MoAAFh4j1fHGl8yZT45Xj0dAABL5dbqUOPLpsw2h6vdAQCwlLZV+6pTjS+ecnlZr17OkRkAgJXwWPVz40uoXFp+rB79364CALDUHKlZzBysbj7DfgIAsAK2Nd1W+mfji6mcO2tNx5+2nmkjAQBYLXdX3zS+pMqZ81V151l3DwCAlXR100uR640vrPJf9lfXnGPfAABYcY9U3ze+uK56jja9bAwAAOe1qzrQ+BK7qnmzuvG8uwQAAKfZW/3U+EK7Kvmlev6CdgYAAM5iV/VG48vtsudAxkMCADBDe5suEBpddJctx/KvOwAAc7Kzer3xpXdZ8lrOugMAsAGerI40vgAvar7LhBkAADbY9uql6q/GF+JFyVrTrP1rL2G9AQBgJu6oPm58Od7s+azpxlsAABhua/VidaLxRXmz5Xj1QrXlklcXAADm5Kbq1epU44vz6KxX+5vGcAIAwKZ2V/Vh40v0qHxa3XvZqwgAABtoS9N881WaHf9D9UyOywAAsMB2VPuqPxpfsOeVk03TZa6fzZIBAMB4t7R85+PXmy5j2j3DdQIAgE3lnuq9xpfvy83bTWf9AQBgJdxfvd/4In6x+aB6ePbLAQAAi2FP9Unji/n58kW1d05rAAAAC2dP9Xnji/rp+bKpuF8xv58OAACLaUv1VHW48cX9o+qJjIQEAIAL8lD1VtOIxo0q7SerN6sH5//zAABgOd1QPVe9W601+9K+Vr1TPfvPdwGwiTnPCLBYdlT3VQ80TbG5vdp5kZ9xtPq6OlQdbJoq89sMnxGAOVLgARbfddVtTRdFbW8q+f/eiPprUzn/vTpSfVudGPCMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAME9/A7XqnoRnVy/jAAAAAElFTkSuQmCC"/>
                                        : <img className=''
                                               src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' fill='%23000000' height='800px' width='800px' version='1.1' id='Capa_1' viewBox='0 0 26.676 26.676' xml:space='preserve'%3E%3Cg%3E%3Cpath d='M26.105,21.891c-0.229,0-0.439-0.131-0.529-0.346l0,0c-0.066-0.156-1.716-3.857-7.885-4.59 c-1.285-0.156-2.824-0.236-4.693-0.25v4.613c0,0.213-0.115,0.406-0.304,0.508c-0.188,0.098-0.413,0.084-0.588-0.033L0.254,13.815 C0.094,13.708,0,13.528,0,13.339c0-0.191,0.094-0.365,0.254-0.477l11.857-7.979c0.175-0.121,0.398-0.129,0.588-0.029 c0.19,0.102,0.303,0.295,0.303,0.502v4.293c2.578,0.336,13.674,2.33,13.674,11.674c0,0.271-0.191,0.508-0.459,0.562 C26.18,21.891,26.141,21.891,26.105,21.891z'/%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3C/g%3E%3C/svg%3E"/>
                                    }
                                </Button>}
                            <Button className='add-custom-btn'
                                    onClick={() => (openAdminUi ? openWizardForNew() : handleOpen())} variant="outlined">
                                <img src="data:image/svg+xml,%3Csvg width='21' height='21' viewBox='0 0 21 21' fill='none'
                             xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.4451
                            20.6823L9.18234 20.6823L9.18234 11.6314L0.131371 11.6314V9.36863L9.18234 9.36863L9.18234 0.317661L11.4451
                            0.317663L11.4451 9.36863L20.496 9.36863V11.6314L11.4451 11.6314L11.4451 20.6823Z' fill='%23010035'/%3E%3C/svg%3E%0A"
                                />
                            </Button>
                            {(openAdminUi) &&
                                <Tooltip title={autoSync ? "Auto-sync enabled (every 5s)" : "Auto-sync disabled"}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => setAutoSync(!autoSync)}
                                    >
                                        {/* Custom Toggle Switch */}
                                        <div
                                            style={{
                                                position: 'relative',
                                                width: '60px',
                                                height: '28px',
                                                background: autoSync ? '#010035' : '#ccc',
                                                borderRadius: '14px',
                                                transition: 'all 0.3s ease',
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '0 4px',
                                                boxShadow: autoSync ? '0 2px 8px rgba(1, 0, 53, 0.3)' : 'none'
                                            }}
                                        >
                                            {/* Sliding circle */}
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    width: '20px',
                                                    height: '20px',
                                                    background: '#fff',
                                                    borderRadius: '50%',
                                                    transition: 'left 0.3s ease',
                                                    left: autoSync ? '34px' : '6px',
                                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
                                                }}
                                            />
                                            {/* ON/OFF Text */}
                                            <span
                                                style={{
                                                    position: 'absolute',
                                                    left: '6px',
                                                    fontSize: '10px',
                                                    fontWeight: 'bold',
                                                    color: autoSync ? '#fff' : 'transparent',
                                                    transition: 'color 0.3s ease',
                                                    opacity: autoSync ? 1 : 0,
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.5px',
                                                    top:'9px',
                                                    fontFamily:'Gilroy-SemiBold, sans-serif'
                                                }}
                                            >
                                                ON
                                            </span>
                                            <span
                                                style={{
                                                    position: 'absolute',
                                                    right: '4px',
                                                    fontSize: '10px',
                                                    fontWeight: 'bold',
                                                    color: autoSync ? 'transparent' : '#666',
                                                    transition: 'color 0.3s ease',
                                                    opacity: autoSync ? 0 : 1,
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.5px',
                                                    top:'9px',
                                                    fontFamily:'Gilroy-SemiBold, sans-serif'

                                                }}
                                            >
                                                OFF
                                            </span>
                                        </div>
                                    </div>
                                </Tooltip>
                            }
                            <Button className='add-custom-btn-blue'
                                    onClick={handleToolbarRefresh} variant="contained">
                                <img
                                    src="data:image/svg+xml,%3Csvg width='23' height='23' viewBox='0 0 23 23' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.5798 10.0625H22.2327C22.5374 10.0625 22.7039 10.4179 22.5088 10.6519L19.6823 14.0437C19.5387 14.2161 19.2739 14.2161 19.1302 14.0437L16.3037 10.6519C16.1086 10.4179 16.2751 10.0625 16.5798 10.0625Z' fill='white'/%3E%3Cpath d='M0.767289 12.9375H6.42023C6.72492 12.9375 6.89137 12.5821 6.69631 12.3481L3.86984 8.9563C3.72616 8.78388 3.46135 8.78388 3.31768 8.9563L0.491209 12.3481C0.29615 12.5821 0.462597 12.9375 0.767289 12.9375Z' fill='white'/%3E%3Cpath fillRule='evenodd' clipRule='evenodd' d='M11.5 4.3125C9.2683 4.3125 7.27457 5.32876 5.95512 6.92643C5.70235 7.2325 5.24932 7.27571 4.94324 7.02294C4.63717 6.77017 4.59397 6.31714 4.84674 6.01107C6.42756 4.09691 8.8214 2.875 11.5 2.875C15.7287 2.875 19.2453 5.91747 19.9828 9.93265C19.9907 9.97582 19.9984 10.0191 20.0056 10.0625H18.5439C17.8783 6.78181 14.9768 4.3125 11.5 4.3125ZM4.45614 12.9375C5.12172 16.2182 8.02323 18.6875 11.5 18.6875C13.7317 18.6875 15.7254 17.6712 17.0449 16.0736C17.2977 15.7675 17.7507 15.7243 18.0568 15.9771C18.3628 16.2298 18.406 16.6829 18.1533 16.9889C16.5725 18.9031 14.1786 20.125 11.5 20.125C7.27131 20.125 3.75473 17.0825 3.0172 13.0674C3.00927 13.0242 3.00166 12.9809 2.99438 12.9375H4.45614Z' fill='white'/%3E%3C/svg%3E%0A"/>
                            </Button>
                        </Stack>
                    </div>
                    <TableContainer className='box-table'>
                        {openAdminUi ?
                            <Table className='custom-style-table device' sx={{minWidth: 650}} aria-label="simple table">
                                <TableHead sx={{background: '#dedede'}}>
                                    <TableRow>
                                        <TableCell align="left">Pivot Name</TableCell>
                                        <TableCell align="left">Status</TableCell>
                                        {/*<TableCell align="left">Temp</TableCell>*/}
                                        {/*<TableCell align="left">Pivot Was Rotated</TableCell>*/}
                                        <TableCell align="left">Location</TableCell>
                                        <TableCell align="left"></TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {isLoading ? (
                                        Array.from({length: 4}).map((_, i) => (
                                            <TableRow key={i} sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                                                <TableCell sx={{width: '45%'}}>
                                                    <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                                        <Skeleton variant="rectangular" width={19} height={19} sx={{borderRadius: '3px', flexShrink: 0}} />
                                                        <Skeleton variant="rectangular" width={18} height={18} sx={{flexShrink: 0}} />
                                                        <div style={{marginLeft: 60}}>
                                                            <Skeleton variant="text" width={130} height={22} />
                                                            <Skeleton variant="text" width={90} height={16} />
                                                        </div>
                                                    </div>
                                                </TableCell>
                                                <TableCell sx={{width: '25%'}}>
                                                    <Skeleton variant="rectangular" width={70} height={26} sx={{borderRadius: '20px'}} />
                                                </TableCell>
                                                <TableCell sx={{width: '15%'}}>
                                                    <Skeleton variant="text" width={40} height={22} />
                                                </TableCell>
                                                <TableCell sx={{width: '15%'}}>
                                                    <div style={{display: 'flex', gap: '10px'}}>
                                                        <Skeleton variant="rectangular" width={15} height={15} />
                                                        <Skeleton variant="rectangular" width={20} height={20} />
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : rows?.map((row,index) => (
                                        <TableRow key={row?._id} sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                                            <TableCell align="left" sx={{verticalAlign: 'top', width: '45%'}}>
                                                <div style={{display: 'flex', alignItems: 'flex-start', gap: '8px'}}>
                                                    <div  style={{display: 'flex', alignItems: 'center', gap: '4px', flexShrink: 0}}>
                                                       <div  className='custom-box-open-alert'>
                                                        <div
                                                            style={{
                                                                cursor: 'pointer',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                            onClick={() => toggleDeviceExpand(row?._id)}
                                                        >
                                                            <ExpandMoreIcon
                                                                sx={{
                                                                    fontSize: '18px',
                                                                    transform: expandedDevices[row?._id] ? 'rotate(180deg)' : 'rotate(0deg)',
                                                                    transition: 'transform 0.3s',
                                                                    flexShrink: 0,
                                                                    color: row?.errorHistory?.length > 0 ? '#000' : 'inherit',
                                                                }}
                                                            />
                                                        </div>
                                                       </div>
                                                    </div>
                                                    <div style={{marginLeft:60}} >
                                                        <div className='deviceName'>{row.deviceName}</div>
                                                        <div className='deviceId'>{row.deviceId}</div>
                                                    </div>
                                                </div>

                                                <Collapse
                                                    in={expandedDevices[row?._id]}
                                                    timeout={500}
                                                    sx={{
                                                        '& .MuiCollapse-wrapper': {
                                                            transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)'
                                                        },
                                                        '& .MuiCollapse-wrapperInner': {
                                                            transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)'
                                                        }
                                                    }}
                                                >
                                                    <div style={{marginTop: '10px', marginLeft: '67px'}}>
                                                        {(() => {
                                                            // errorHistory - прочитані помилки (історія) - завжди останні 5
                                                            const readAlerts = (row?.errorHistory || []).slice(0, 5);
                                                            return (<>
                                                        <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                                            <Typography variant="caption" sx={{fontWeight: 700, color: '#000'}}>
                                                                Alerts history:
                                                            </Typography>
                                                            {readAlerts.length > 0 && (
                                                                <button
                                                                    onClick={() => removeAlerts.mutate(row._id)}
                                                                    style={{
                                                                        fontSize: '11px',
                                                                        color: '#B60000',
                                                                        background: 'none',
                                                                        border: '1px solid #B60000',
                                                                        borderRadius: '4px',
                                                                        padding: '1px 6px',
                                                                        cursor: 'pointer',
                                                                        lineHeight: '16px',
                                                                    }}
                                                                >
                                                                    Remove
                                                                </button>
                                                            )}
                                                        </div>
                                                        {(() => {
                                                            if (readAlerts.length > 0) {
                                                                return (
                                                                    <ul className="list-alert">
                                                                        {readAlerts.map((error, idx) => (
                                                                            <li key={error._id || idx}>
                                                                              <div className="alert-item-row">
                                                                                  <div className="alert-date">
                                                                                      {formatAlertDate(error.eventAt)}
                                                                                  </div>
                                                                                  <div className="alert-errors">
                                                                                      {error.errors?.map((err, errIdx) => (
                                                                                          <span key={err._id || errIdx} className="alert-error-item">
                                                                                              {getErrorIcon(err.code)}
                                                                                              <span>{err.message}</span>
                                                                                          </span>
                                                                                      ))}
                                                                                  </div>
                                                                              </div>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                );
                                                            } else {
                                                                return <p style={{color: '#7C7C7C', fontSize: '12px', marginTop: '8px'}}>No alerts yet</p>;
                                                            }
                                                        })()}
                                                    </>);
                                                        })()}
                                                    </div>
                                                </Collapse>
                                            </TableCell>
                                            <TableCell align="left" sx={{verticalAlign: 'top', width: '25%'}}>
                                                <div className='status-box'>
                                                    <div className='icon-box'>
                                                        <img onClick={() => handleManualRefresh(row._id)}
                                                             className={manualRefreshingId === row._id ? 'spinning' : ''}
                                                             src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='35' height='27' viewBox='0 0 35 27' fill='none'%3E%3Cpath d='M25.2305 11.3125H33.8328C34.2965 11.3125 34.5498 11.8533 34.253 12.2095L29.9518 17.3709C29.7332 17.6332 29.3302 17.6332 29.1116 17.3709L24.8104 12.2095C24.5136 11.8533 24.7669 11.3125 25.2305 11.3125Z' fill='%237C7C7C'/%3E%3Cpath d='M1.16804 15.6875H9.77034C10.234 15.6875 10.4873 15.1467 10.1905 14.7905L5.88931 9.62915C5.67067 9.36678 5.2677 9.36678 5.04907 9.62915L0.747916 14.7905C0.451087 15.1467 0.704377 15.6875 1.16804 15.6875Z' fill='%237C7C7C'/%3E%3Cpath fillRule='evenodd' clipRule='evenodd' d='M17.5004 2.5625C14.1044 2.5625 11.0704 4.10899 9.06256 6.54023C8.67791 7.00599 7.98851 7.07174 7.52275 6.68708C7.05699 6.30243 6.99124 5.61303 7.3759 5.14727C9.7815 2.23443 13.4243 0.375 17.5004 0.375C23.9354 0.375 29.2867 5.00485 30.4091 11.1149C30.4211 11.1806 30.4327 11.2465 30.4438 11.3125H28.2194C27.2065 6.32015 22.7912 2.5625 17.5004 2.5625ZM6.78151 15.6875C7.79435 20.6799 12.2097 24.4375 17.5004 24.4375C20.8965 24.4375 23.9305 22.891 25.9383 20.4598C26.323 19.994 27.0124 19.9283 27.4781 20.3129C27.9439 20.6976 28.0096 21.387 27.625 21.8527C25.2194 24.7656 21.5766 26.625 17.5004 26.625C11.0655 26.625 5.71414 21.9951 4.59182 15.8851C4.57975 15.8194 4.56817 15.7535 4.55708 15.6875H6.78151Z' fill='%237C7C7C'/%3E%3C/svg%3E"
                                                             alt=""/>
                                                    </div>
                                                    <div
                                                        className={`custom-box-status ${row.status ? 'on' : 'off'}`}>
                                                        <span> <img src={row.status ? onIcon:offIcon} alt="icon"/>{row.status ? 'on' : 'off'}</span>
                                                    </div>
                                                    {(() => {
                                                        // recentErrors - непрочитані помилки
                                                        const unreadErrors = row?.recentErrors || [];
                                                        if (unreadErrors.length > 0 && !removedPopup.includes(row?._id)) {
                                                            // Збираємо унікальні коди помилок
                                                            const uniqueErrorCodes = [];
                                                            unreadErrors.forEach(error => {
                                                                error.errors?.forEach(err => {
                                                                    if (!uniqueErrorCodes.includes(err.code) && uniqueErrorCodes.length < 2) {
                                                                        uniqueErrorCodes.push(err.code);
                                                                    }
                                                                });
                                                            });
                                                            return (
                                                                <div className='alertInfo' onClick={() => handleOpenAlert({...row, recentErrors: unreadErrors})}>
                                                                    {uniqueErrorCodes.map((code, idx) => (
                                                                        <span key={idx}>{getErrorIcon(code)}</span>
                                                                    ))}
                                                                    <span>Attention!</span>
                                                                </div>
                                                            );
                                                        }
                                                        // No real device error to show - fall back to the
                                                        // calibration-state pill, same slot, never both at once.
                                                        // An interrupted run means the device has been offline for 20+
                                                        // minutes, so "No connection" would always win here and the red
                                                        // Attention! would never show - it needs to stand out instead.
                                                        const calibAlert = CALIB_ALERT[row.calibState === 'interrupted' ? 'interrupted' : (!row.status ? 'no_link' : row.calibState)]
                                                        if (!calibAlert) return null
                                                        const clickable = CALIB_POPUP_STATES.includes(row.calibState)
                                                        return (
                                                            <span
                                                                className={`alert-pill ${calibAlert.color}`}
                                                                onClick={() => (clickable ? setPopupRowId(row._id) : undefined)}
                                                                style={{ cursor: clickable ? 'pointer' : 'default' }}
                                                            >
                                                                {calibAlert.text}
                                                            </span>
                                                        );
                                                    })()}
                                                </div>
                                            </TableCell>
                                            <TableCell align="left" sx={{verticalAlign: 'top', width: '15%'}}>
                                                <div className='box-calibration'>
                                                    <div>
                                                        {(row.az ?? row.azimuth) != null && (
                                                            <MiniDonut
                                                                arcStart={row.calibState === 'done' && row.zoneStartAngle != null ? row.zoneStartAngle : undefined}
                                                                arcEnd={row.calibState === 'done' && row.zoneStartAngle != null ? (row.zoneStartAngle + (row.sweepDegrees ?? 0)) % 360 : undefined}
                                                                sweepDegrees={row.sweepDegrees ?? 0}
                                                                currentAngle={Number(row.az ?? row.azimuth)}
                                                            />
                                                        )}
                                                        {(row.az ?? row.azimuth) != null ? `${row.az ?? row.azimuth}°` : '—'}
                                                    </div>
                                                    <div style={{fontSize: '11px', color: '#7C7C7C'}}>
                                                        Sweep: {row.sweepDegrees != null ? `${row.sweepDegrees}°` : '—'}
                                                    </div>
                                                    {row.calibState === 'done' ? (
                                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                                            <div className='calibration-btn'
                                                                 onClick={() => openQuickAngle(row)}>set current°
                                                            </div>
                                                            <div className='calibration-btn'
                                                                 onClick={() => setRecalRowId(row?._id)}>recalibrate
                                                            </div>
                                                        </Box>
                                                    ) : renderCalibAction(row)}

                                                </div>
                                            </TableCell>
                                            <TableCell align="left" sx={{verticalAlign: 'top', width: '15%'}}>
                                                <div className='flex action-box'>
                                                <div className='pointer' onClick={(e) => editDeviceFn(row?._id)}>
                                                        <svg className='edit-icon' xmlns="http://www.w3.org/2000/svg" width="15" height="15"
                                                             viewBox="0 0 15 15" fill="none">
                                                            <path
                                                                d="M12.0502 0.137294C11.8672 -0.0457646 11.5704 -0.0457646 11.3873 0.137294L9.84376 1.68084L13.3192 5.15626L14.8627 3.61271C15.0458 3.42965 15.0458 3.13285 14.8627 2.94979L12.0502 0.137294Z"
                                                                fill="#7C7C7C"/>
                                                            <path
                                                                d="M12.6563 5.81917L9.18084 2.34376L3.0871 8.4375H3.28125C3.54013 8.4375 3.75 8.64737 3.75 8.90625V9.375H4.21875C4.47763 9.375 4.6875 9.58487 4.6875 9.84375V10.3125H5.15625C5.41513 10.3125 5.625 10.5224 5.625 10.7812V11.25H6.09375C6.35263 11.25 6.5625 11.4599 6.5625 11.7188V11.9129L12.6563 5.81917Z"
                                                                fill="#7C7C7C"/>
                                                            <path
                                                                d="M5.65468 12.8207C5.63549 12.7696 5.625 12.7141 5.625 12.6562V12.1875H5.15625C4.89737 12.1875 4.6875 11.9776 4.6875 11.7188V11.25H4.21875C3.95987 11.25 3.75 11.0401 3.75 10.7812V10.3125H3.28125C3.02237 10.3125 2.8125 10.1026 2.8125 9.84375V9.375H2.34375C2.28587 9.375 2.23045 9.36451 2.17927 9.34533L2.01231 9.51229C1.96742 9.55718 1.93212 9.61072 1.90854 9.66966L0.0335402 14.3572C-0.0361004 14.5313 0.00471552 14.7301 0.137307 14.8627C0.269899 14.9953 0.468751 15.0361 0.642853 14.9665L5.33035 13.0915C5.38929 13.0679 5.44283 13.0326 5.48772 12.9877L5.65468 12.8207Z"
                                                                fill="#7C7C7C"/>
                                                        </svg>
                                                    </div>
                                                    <div className='pointer'
                                                         onClick={(e) => {
                                                             if (window.confirm('Are you sure? You can still add the device again at any time')) {
                                                                 removeDevice.mutate(row?._id);
                                                             }
                                                         }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                             viewBox="0 0 20 20" fill="none">
                                                            <path
                                                                d="M13.75 1.875V3.125H18.125C18.4702 3.125 18.75 3.40482 18.75 3.75C18.75 4.09518 18.4702 4.375 18.125 4.375H17.452L16.386 17.6994C16.2821 18.9986 15.1974 20 13.894 20H6.10599C4.80259 20 3.71789 18.9986 3.61395 17.6994L2.548 4.375H1.875C1.52982 4.375 1.25 4.09518 1.25 3.75C1.25 3.40482 1.52982 3.125 1.875 3.125H6.25V1.875C6.25 0.839466 7.08947 0 8.125 0H11.875C12.9105 0 13.75 0.839466 13.75 1.875ZM7.5 1.875V3.125H12.5V1.875C12.5 1.52982 12.2202 1.25 11.875 1.25H8.125C7.77982 1.25 7.5 1.52982 7.5 1.875ZM5.62499 6.28563L6.24999 16.9106C6.27025 17.2552 6.56603 17.5181 6.91061 17.4978C7.25519 17.4776 7.5181 17.1818 7.49783 16.8372L6.87283 6.21222C6.85256 5.86764 6.55679 5.60473 6.21221 5.625C5.86762 5.64527 5.60471 5.94104 5.62499 6.28563ZM13.7878 5.62608C13.4432 5.60581 13.1474 5.86872 13.1272 6.2133L12.5022 16.8383C12.4819 17.1829 12.7448 17.4787 13.0894 17.4989C13.434 17.5192 13.7297 17.2563 13.75 16.9117L14.375 6.2867C14.3953 5.94212 14.1324 5.64635 13.7878 5.62608ZM10 5.625C9.65483 5.625 9.375 5.90482 9.375 6.25V16.875C9.375 17.2202 9.65483 17.5 10 17.5C10.3452 17.5 10.625 17.2202 10.625 16.875V6.25C10.625 5.90482 10.3452 5.625 10 5.625Z"
                                                                fill="#7C7C7C"/>
                                                        </svg>
                                                    </div>
                                                    {/*<div className='pointer'*/}
                                                    {/*     onClick={() => alert('Update data current Pivot?')}>*/}
                                                    {/*    <Cached/>*/}
                                                    {/*</div>*/}
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table> :
                            <Table className='custom-style-table' sx={{minWidth: 650}} aria-label="simple table">
                                <TableHead sx={{background: '#dedede'}}>
                                    <TableRow>
                                        <TableCell align="left">Email</TableCell>
                                        <TableCell align="left">First Name</TableCell>
                                        <TableCell align="left">Last Name</TableCell>

                                        <TableCell align="left">Role</TableCell>
                                        <TableCell align="left">Status</TableCell>
                                        <TableCell align="left"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {isLoading ? (
                                        Array.from({length: 4}).map((_, i) => (
                                            <TableRow key={i} sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                                                <TableCell><Skeleton variant="text" width={160} height={22} /></TableCell>
                                                <TableCell><Skeleton variant="text" width={90} height={22} /></TableCell>
                                                <TableCell><Skeleton variant="text" width={90} height={22} /></TableCell>
                                                <TableCell><Skeleton variant="text" width={50} height={22} /></TableCell>
                                                <TableCell><Skeleton variant="text" width={60} height={22} /></TableCell>
                                                <TableCell>
                                                    <div style={{display: 'flex', gap: '10px'}}>
                                                        <Skeleton variant="rectangular" width={20} height={20} />
                                                        <Skeleton variant="rectangular" width={20} height={20} />
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : users?.map((row) => (
                                        <TableRow key={row?._id} sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                                            <TableCell align="left">{row.email}</TableCell>
                                            <TableCell align="left">{row.firstName}</TableCell>
                                            <TableCell align="left">{row.lastName}</TableCell>

                                            <TableCell align="left">{row.role}</TableCell>
                                            <TableCell align="left">{row.status}</TableCell>
                                            <TableCell align="left">
                                                <div className='flex action-box'>
                                                    <div className='pointer' onClick={(e) => editUserFn(row?._id)}>
                                                        <img className='edit-icon'
                                                             src="data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.067 0.183058C15.8229 -0.0610194 15.4272 -0.0610194 15.1831 0.183058L13.125 2.24112L17.7589 6.87501L19.817 4.81694C20.061 4.57286 20.061 4.17714 19.817 3.93306L16.067 0.183058Z' fill='%237C7C7C'/%3E%3Cpath d='M16.875 7.75889L12.2411 3.12501L4.11613 11.25H4.375C4.72018 11.25 5 11.5298 5 11.875V12.5H5.625C5.97018 12.5 6.25 12.7798 6.25 13.125V13.75H6.875C7.22018 13.75 7.5 14.0298 7.5 14.375V15H8.125C8.47018 15 8.75 15.2798 8.75 15.625V15.8839L16.875 7.75889Z' fill='%237C7C7C'/%3E%3Cpath d='M7.53957 17.0943C7.51399 17.0261 7.5 16.9522 7.5 16.875V16.25H6.875C6.52982 16.25 6.25 15.9702 6.25 15.625V15H5.625C5.27982 15 5 14.7202 5 14.375V13.75H4.375C4.02982 13.75 3.75 13.4702 3.75 13.125V12.5H3.125C3.04783 12.5 2.97393 12.486 2.90569 12.4604L2.68308 12.6831C2.62323 12.7429 2.57616 12.8143 2.54472 12.8929L0.0447203 19.1429C-0.0481339 19.375 0.00628736 19.6402 0.183076 19.8169C0.359866 19.9937 0.625002 20.0482 0.857137 19.9553L7.10714 17.4553C7.18573 17.4239 7.25711 17.3768 7.31696 17.3169L7.53957 17.0943Z' fill='%237C7C7C'/%3E%3C/svg%3E%0A"
                                                             alt="edit"/>
                                                    </div>
                                                    <div className='pointer'

                                                         onClick={(e) => {
                                                             if (window.confirm('Are you sure? You can still add the user again at any time')) {
                                                                 removeUser.mutate(row?._id)
                                                             }
                                                         }}>
                                                        <img
                                                            src="data:image/svg+xml,%3Csvg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.1875 2.34375V3.90625H22.6562C23.0877 3.90625 23.4375 4.25603 23.4375 4.6875C23.4375 5.11897 23.0877 5.46875 22.6562 5.46875H21.815L20.4826 22.1242C20.3526 23.7483 18.9968 25 17.3675 25H7.63249C6.00324 25 4.64737 23.7483 4.51744 22.1242L3.185 5.46875H2.34375C1.91228 5.46875 1.5625 5.11897 1.5625 4.6875C1.5625 4.25603 1.91228 3.90625 2.34375 3.90625H7.8125V2.34375C7.8125 1.04933 8.86183 0 10.1562 0H14.8438C16.1382 0 17.1875 1.04933 17.1875 2.34375ZM9.375 2.34375V3.90625H15.625V2.34375C15.625 1.91228 15.2752 1.5625 14.8438 1.5625H10.1562C9.72478 1.5625 9.375 1.91228 9.375 2.34375ZM7.03123 7.85703L7.81248 21.1383C7.83782 21.569 8.20753 21.8976 8.63826 21.8723C9.06899 21.847 9.39762 21.4773 9.37228 21.0465L8.59103 7.76528C8.5657 7.33455 8.19598 7.00592 7.76526 7.03125C7.33453 7.05659 7.00589 7.4263 7.03123 7.85703ZM17.2347 7.0326C16.804 7.00726 16.4343 7.33589 16.409 7.76662L15.6277 21.0479C15.6024 21.4786 15.931 21.8483 16.3617 21.8736C16.7925 21.899 17.1622 21.5704 17.1875 21.1396L17.9688 7.85838C17.9941 7.42765 17.6655 7.05793 17.2347 7.0326ZM12.5 7.03125C12.0685 7.03125 11.7188 7.38103 11.7188 7.8125V21.0938C11.7188 21.5252 12.0685 21.875 12.5 21.875C12.9315 21.875 13.2813 21.5252 13.2813 21.0938V7.8125C13.2813 7.38103 12.9315 7.03125 12.5 7.03125Z' fill='%237C7C7C'/%3E%3C/svg%3E%0A"
                                                            alt="delete"/>
                                                    </div>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        }
                    </TableContainer>
                </div>
            </div>
            <Footer/>
        </>
    );
};

export default Dashboard
